import React, { useEffect, useMemo, useRef, useState } from "react";
import { Layout, Typography, Button, Row, Col, message, Modal, Alert, Space, Spin } from "antd";
import moment from 'moment';
import useAuth from "../hooks/useAuth";
import { canViewDpatScoreSheets, isDpatDistrictRestrictedViewer } from "config/contextModules";
import { CheckCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { useReactToPrint } from 'react-to-print';
import { checkECANDGAMeetingFulfillment, buildGroupedMeetingSummaryRow, formatSubStatutoryMeetings, formatSubStructureMeetings, getFileLinkIfExist, getMeetingRank, getTrackerEventDataValue, getYearFromDateValue, parseOptionalCount, calculatePercentage as calcPercentage, isDateInSelectedYear, formatTrackerDate } from "../utils/utils";
import {
  allGroupedMeetingLinksUploaded,
  allStatutorySubCommitteeRowsComplete,
  documentHubLinksComplete,
  isEvidenceLinkUploaded,
  rowHasAllEvidenceLinks,
  rowsHaveAllEvidenceLinks,
} from "../utils/renderDpatEvidenceLink";

import { ECAMeetingColumns, ETCMeetingColumns, internalAuditColumns, internalAuditMeetingColumns, managementMeetingColumns, membersColumns, PRCCMeetingColumns, revenueSharingColumns, serviceDecisionColumns, serviceDeliveryDecisionColumns, spcMeetingColumns, subCommitteeCompositionColumns, subStatutoryMeetingsColumns, subStructureColumns, subStructureEstablishmentColumns, townHallMeetingColumns } from "../utils/tableColums";
import instance from "../api/cmsapi";
import DpatScoreSheetsBlock from "./DpatScoreSheetsBlock";
import Petition from "./Petition";
import CommentAndGabsSummary from "./CommentAndGabsSummary";
import QualityAssuranceCommentsSummary from "./QualityAssuranceCommentsSummary";
import PetitionCommittee from "./PetitionCommittee";
import { useDpatCmsYearSetup } from "../hooks/useDpatCmsYearSetup";
import DpatDocumentViewerProvider from "./DPAT/setup/DpatDocumentViewer";
import DpatAnnexNavigator from "./DpatAnnexNavigator";
import { getDpatAssessmentDateDisplay } from "../utils/formatDpatAssessmentDate";
import { filterRecordsByDpatYearAttribute, isDpatIncidentYear, isDpatScoreRelaxationExempt, syncDpatScoreRelaxation } from "../utils/dpatScoreRelaxation";
import UiButton from "components/ui/Button";
import Icon from "components/AppIcon";
import GAMeeting from "./DPAT/compliance-indicators/GAMeeting";
import AAPBudgetAproval from "./DPAT/compliance-indicators/AAPBudgetAproval";
import SubStructureMeeting from "./DPAT/compliance-indicators/SubStructureMeeting";
import ExecutiveCommitteeMember from "./DPAT/compliance-indicators/ExecutiveCommitteeMember";
import SubStructureCommiteeMeeting from "./DPAT/compliance-indicators/SubStructureCommitteMeeting";
import ManagementMeeting from "./DPAT/compliance-indicators/ManagementMeeting";
import PRCCMeeting from "./DPAT/compliance-indicators/PRCCMeeting";
import EntityTenderCommitteeMeeting from "./DPAT/compliance-indicators/EntityTenderCommiteeMeeting";
import SPCEntityTenderCommittee from "./DPAT/compliance-indicators/SCPEntityTenderCommittee";
import InternalAuditUnitFunctionality from "./DPAT/compliance-indicators/InternalAuditUnitFunctionality";
import AuditCommiteeMeeting from "./DPAT/compliance-indicators/AuditCommiteeMetting";
import ClientServiceFunctionality from "./DPAT/compliance-indicators/ClientServiceFunctionality";
import AAPPublication from "./DPAT/compliance-indicators/AAPPublication";
import AuditorGeneralGAMeeting from "./DPAT/compliance-indicators/AuditorGeneralGAMeeting";
import TownHollMeeting from "./DPAT/compliance-indicators/TownHollMeeting";
import GeneralAssemblyManagementActions from "./DPAT/service-delivery-indicators/GeneralAssemblyManagmentActions";
import GASupport from "./DPAT/service-delivery-indicators/GASupport";
import WaterServices from "./DPAT/service-delivery-indicators/WaterServices";
import ElectricityServices from "./DPAT/service-delivery-indicators/ElectricityServices";
import SanitationServices from "./DPAT/service-delivery-indicators/SanitationSevices";
import MaintenanceInfrastructure from "./DPAT/service-delivery-indicators/MaintenanceInfrastructure";
import ClientServiceCharter from "./DPAT/service-delivery-indicators/ClientServiceCharter";
import TransportationNetworkService from "./DPAT/service-delivery-indicators/TransportationNetworkService";
import BuildingInspectorateUnit from "./DPAT/service-delivery-indicators/BuildingInspectorateUnit";
import PermitProcessingIssuance from "./DPAT/service-delivery-indicators/PermitProcessingIssuance";
import StreetNaming from "./DPAT/service-delivery-indicators/StreetNaming";
import SocialProtectionServices from "./DPAT/service-delivery-indicators/SocialProtectionServices";
import DistrictHotlineNumber from "./DPAT/service-delivery-indicators/DistrictHotlineNumber";
import PWDService from "./DPAT/service-delivery-indicators/PWDService";
import DeepeningGenderMainstreaming from "./DPAT/service-delivery-indicators/DeepeningGenderMainstreaming";
import NutritionIntervention from "./DPAT/service-delivery-indicators/NutritionIntervention";
import SanitationServiceProviders from "./DPAT/service-delivery-indicators/SanitationServiceProviders";
import DumpingSite from "./DPAT/service-delivery-indicators/DumpingSite";
import FoodVendors from "./DPAT/service-delivery-indicators/FoodVendors";
import PublicSchoolFacility from "./DPAT/service-delivery-indicators/PublicSchoolFacility";
import ClimateChangeIntervention from "./DPAT/service-delivery-indicators/ClimateChangeIntervention";
import DistrictLEDActivityPlan from "./DPAT/service-delivery-indicators/DistrictLEDActivityPlan";
import BusinessAndJobPromotion from "./DPAT/service-delivery-indicators/BusinessAndJobPromotion";
import AgroProcessingFacilitySupport from "./DPAT/service-delivery-indicators/AgroProcessingFacilitySupport";
import BusinessCommunityEngagement from "./DPAT/service-delivery-indicators/BusinessCommunityEngagement";
import AAPImplementation from "./DPAT/performance-indicators/AAPImplementation";
import MonitoringProjectAndActivity from "./DPAT/performance-indicators/MonitoringProjectAndActivity";
import ContractManagementAndAdmins from "./DPAT/performance-indicators/ContractManagementAndAdmins";
import FollowUpDeduction from "./DPAT/performance-indicators/FollowUpDeduction";
import EnvironmentalAndSocialSafeGuard from "./DPAT/performance-indicators/EnvironmentalAndSocialSafeGuard";
import RateableRevenu from "./DPAT/performance-indicators/RateableRevenu";
import AuditCommitteeResponsiveness from "./DPAT/performance-indicators/AuditCommitteeResponsiveness";
import AuditInfractions from "./DPAT/performance-indicators/AuditInfractions";
import EducationServiceSupport from "./DPAT/performance-indicators/EducationServiceSupport";
import HealthServiceSupport from "./DPAT/performance-indicators/HealthServiceSupport";
import AgricultureSupport from "./DPAT/performance-indicators/AgricultureSupport";
import GeneralAssemblyDecision from "./DPAT/service-delivery-indicators/GeneralAssemblyDecision";
import axios from "api/axios";
import QualityAssuranceEditor from "./QualityAssuranceEditor";
import DpatMemoAndScoresGate from "./DpatMemoAndScoresGate";
import { useCreateComment } from "service/comment.service";
import {
    fetchAssessmentStartTables,
    isDpatAssessmentLocked,
} from "../utils/dpatAssessmentStartData";
import { DpatCommentFeedbackProvider } from "../context/DpatCommentFeedbackContext";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const DPAT_ANNEX_LABELS = [
    "Annex 1 — Compliance indicators (CI)",
    "Annex 2 — Service delivery indicators (SDI)",
    "Annex 3 — Performance indicators (PI)",
    "Annex 4 — Summary scoring and comments",
];
const DPAT_ANNEX_COUNT = 4;

function collectDpatAssessmentTables(refs) {
    return {
        gaMeeting: refs.gaMeeting.current?.getData(),
        aapBudgetApproval: refs.aapBudgetApproval.current?.getData(),
        subStructureMeeting: refs.subStructureMeeting.current?.getData(),
        executiveCommitteeMember: refs.executiveCommitteeMember.current?.getData(),
        subStructureCommitteeMeeting: refs.subStructureCommitteeMeeting.current?.getData(),
        managementMeeting: refs.managementMeeting.current?.getData(),
        prccMeeting: refs.prccMeeting.current?.getData(),
        entityTenderCommitteeMeeting: refs.entityTenderCommitteeMeeting.current?.getData(),
        spcEntityTenderCommittee: refs.spcEntityTenderCommittee.current?.getData(),
        internalAuditUnitFunctionality: refs.internalAuditUnitFunctionality.current?.getData(),
        auditCommitteeMeeting: refs.auditCommitteeMeeting.current?.getData(),
        clientServiceFunctionality: refs.clientServiceFunctionality.current?.getData(),
        aapPublication: refs.aapPublication.current?.getData(),
        auditorGeneralGAMeeting: refs.auditorGeneralGAMeeting.current?.getData(),
        townHallMeeting: refs.townHallMeeting.current?.getData(),
        generalAssemblyDecision: refs.generalAssemblyDecision.current?.getData(),
        generalAssemblyManagementActions: refs.generalAssemblyManagementActions.current?.getData(),
        gaSupport: refs.gaSupport.current?.getData(),
        waterServices: refs.waterServices.current?.getData(),
        electricityServices: refs.electricityServices.current?.getData(),
        sanitationServices: refs.sanitationServices.current?.getData(),
        maintenanceInfrastructure: refs.maintenanceInfrastructure.current?.getData(),
        clientServiceCharter: refs.clientServiceCharter.current?.getData(),
        transportationNetworkService: refs.transportationNetworkService.current?.getData(),
        buildingInspectorateUnit: refs.buildingInspectorateUnit.current?.getData(),
        permitProcessingIssuance: refs.permitProcessingIssuance.current?.getData(),
        streetNaming: refs.streetNaming.current?.getData(),
        socialProtectionServices: refs.socialProtectionServices.current?.getData(),
        shelterTransactionalHousing: refs.shelterTransactionalHousing.current?.getData(),
        districtHotlineNumber: refs.districtHotlineNumber.current?.getData(),
        pwdService: refs.pwdService.current?.getData(),
        deepeningGenderMainstreaming: refs.deepeningGenderMainstreaming.current?.getData(),
        nutritionIntervention: refs.nutritionIntervention.current?.getData(),
        sanitationServiceProviders: refs.sanitationServiceProviders.current?.getData(),
        dumpingSite: refs.dumpingSite.current?.getData(),
        foodVendors: refs.foodVendors.current?.getData(),
        publicSchoolFacility: refs.publicSchoolFacility.current?.getData(),
        climateChangeIntervention: refs.climateChangeIntervention.current?.getData(),
        districtLEDActivityPlan: refs.districtLEDActivityPlan.current?.getData(),
        businessAndJobPromotion: refs.businessAndJobPromotion.current?.getData(),
        agroProcessingFacilitySupport: refs.agroProcessingFacilitySupport.current?.getData(),
        businessCommunityEngagement: refs.businessCommunityEngagement.current?.getData(),
        aapImplementation: refs.aapImplementation.current?.getData(),
        monitoringProjectAndActivity: refs.monitoringProjectAndActivity.current?.getData(),
        contractManagementAndAdmins: refs.contractManagementAndAdmins.current?.getData(),
        followUpDeduction: refs.followUpDeduction.current?.getData(),
        environmentalAndSocialSafeGuard: refs.environmentalAndSocialSafeGuard.current?.getData(),
        capacityBuildingImplementation: refs.capacityBuildingImplementation.current?.getData(),
        postTrainingEvaluation: refs.postTrainingEvaluation.current?.getData(),
        rateableRevenue: refs.rateableRevenue.current?.getData(),
        auditCommitteeResponsiveness: refs.auditCommitteeResponsiveness.current?.getData(),
        auditInfractions: refs.auditInfractions.current?.getData(),
        educationServiceSupport: refs.educationServiceSupport.current?.getData(),
        healthServiceSupport: refs.healthServiceSupport.current?.getData(),
        agricultureSupport: refs.agricultureSupport.current?.getData(),
    };
}

const streetNamingColumn = [
    { title: "Street Naming and Property Addressing Database (NOT Excel) available (Yes/No)", dataIndex: "street", key: "street" },
    { title: "Street Addressing Map of district displayed at Assembly Premises (Yes/No)", dataIndex: "displayed", key: "displayed" },
    { title: "Street Addressing Map of district displayed at Substructures (Yes/No)", dataIndex: "map", key: "map" }
];

const streetNamingInstallationColumn = [
    { title: "No. of streets available on database (a)", dataIndex: "street", key: "street" },
    { title: "Number of streets named (b)", dataIndex: "streetNamedNo", key: "streetNamedNo" },
    { title: "Number of street signage’s installed (c)", dataIndex: "streetNamedInstalled", key: "streetNamedInstalled" }
];





// Main Component
const DPATAssessmentSheet = ({
    props,
    onAssessmentStarted,
    bulkSnapshotRequest,
    onBulkSnapshotReady,
    onBulkSnapshotError,
    onBulkSnapshotCollectorReady,
    bulkSnapshotMode = false,
}) => {
    const createCommentMutation = useCreateComment();
    const contentToPrint = useRef(null);
    const [gaMeetingData, setGaMeetingData] = useState(null);
    const [towHallMeetingData, setTowHallMeetingData] = useState([]);
    const [meetings, setMeetings] = useState(props?.meetings.meetings);
    const [members, setMembers] = useState(props?.members.members);
    const [ecMeetingTemp, setEcMeetingTemp] = useState("");
    const [subStructureActivity, setSubStructureActivity] = useState(props?.subActivity.activities);
    const [subStructuresMeetingData, setSubStructuresMeetingData] = useState([]);
    const [districtGeneral, setDistrictGeneral] = useState(props?.districtGeneral.data);
    const [substructureExpendatureData, setSubstructureExpendatureData] = useState(null);
    const [districtHotlineNumberData, setDistrictHotlineNumberData] = useState([]);
    const [streetNamingData, setStreetNamingData] = useState([]);
    const [socialServicesData, setSocialServicesData] = useState([]);
    const [buildingInspectorateData, setBuildingInspectorateData] = useState(null);
    const [sanitationProvidersData, setSanitationProvidersData] = useState([]);
    const [memberFinanceData, setMemberFinanceData] = useState(null);
    const [guards, setGuards] = useState(null);
    const [transportorsData, setTransportorsData] = useState([]);
    const [nutritionServcieData, setNutritionServcieData] = useState([]);
    const { user } = useAuth();
    const [subStructureActivityData, setSubStructureActivityData] = useState(null);
    const [ecaCompositionData, setEcaCompositionData] = useState(null);
    const [subStatutoryData, setSubStatutoryData] = useState(null);
    const [decisionServiceData, setDecisionServiceData] = useState(null);
    const [decisionDeliveryData, setDecisionDeliveryData] = useState(null);
    const [decisionDeliveryListData, setDecisionDeliveryListData] = useState(null);
    const [managementActionServiceDeliveryData, setManagementActionServiceDeliveryData] = useState([]);
    const [ecaMeetingData, setEcaMeetingData] = useState(null);
    const [prccMeetingData, setPrccMeetingData] = useState(null);
    const [auditCommitteeMeetingData, setAuditCommitteeMeetingData] = useState(null);
    const [internalAuditData, setInternalAuditData] = useState(null);
    const [internalAuditMeetingData, setInternalAuditMeetingData] = useState([]);
    const [etcMeetingData, setEtcMeetingData] = useState(null);
    const [spcMeetingData, setSpcMeetingData] = useState(null);
    const [managementMeetingsData, setManagementMeetingsData] = useState(null);
    const [meetingDecisions, setMeetingDecisions] = useState(props?.decisions.decisions);
    const [subStructures, setSubStructures] = useState(props?.subStructures.sub);
    const [subReports, setSubReports] = useState(props?.subStructures.reports);
    const [subStructureData, setSubStructureData] = useState(null);
    const [subReportData, setSubReportData] = useState(null);
    const [cededRevenueUtilisationData, setCededRevenueUtilisationData] = useState(null);
    const [decisionsData, setDecisionsData] = useState(null);
    const [aapDocuments, setAapDocuments] = useState([]);
    const [year, setYear] = useState(props?.year);
    const [pAndP, setPAndP] = useState(props?.pAndP);
    const [deepGenderData, setDeepGenderData] = useState([]);
    const [sanitationServiceList, setSanitationServiceList] = useState([]);
    const [district, setDistrict] = useState(props.district);
    const [region, setRegion] = useState(props?.region);
    const [cededRevenueUtilisationScore, setCededRevenueUtilisationScore] = useState(0);
    const [assessmentStatus, setAssessmentStatus] = useState(null); // New state for assessment status
    const [progressLoad, setProgressLoad] = useState(false); // New state for loading
    const [sheetAnnexMode, setSheetAnnexMode] = useState("annex");
    const [activeAnnexPage, setActiveAnnexPage] = useState(0);
    const [assessmentStatusLoading, setAssessmentStatusLoading] = useState(true);
    const [assessmentStartTables, setAssessmentStartTables] = useState(null);
    const [assessmentStartLoading, setAssessmentStartLoading] = useState(false);

    const reportYear = useMemo(() => {
        const y = year;
        if (y == null || y === "") return null;
        const n = Number(y);
        return Number.isFinite(n) ? n : y;
    }, [year]);

    const projectProgrammeData = props?.pAndP ?? pAndP;

    const districtOrgUnitId = useMemo(
        () => (district?.value != null ? district.value : null),
        [district],
    );

    syncDpatScoreRelaxation(false, reportYear);

    const { cmsYearSetupLoading, cmsYearSetupEmpty, cmsYearSetupError } = useDpatCmsYearSetup(reportYear);

    const gaMeetingRef = useRef();
    const aapBudgetApprovalRef = useRef();
    const subStructureMeetingRef = useRef();
    const executiveCommitteeMemberRef = useRef();
    const subStructureCommitteeMeetingRef = useRef();
    const managementMeetingRef = useRef();
    const prccMeetingRef = useRef();
    const entityTenderCommitteeMeetingRef = useRef();
    const spcEntityTenderCommitteeRef = useRef();
    const internalAuditUnitFunctionalityRef = useRef();
    const auditCommitteeMeetingRef = useRef();
    const clientServiceFunctionalityRef = useRef();
    const aapPublicationRef = useRef();
    const auditorGeneralGAMeetingRef = useRef();
    const townHallMeetingRef = useRef();
    const generalAssemblyDecisionRef = useRef();
    const generalAssemblyManagementActionsRef = useRef();
    const gaSupportRef = useRef();
    const waterServicesRef = useRef();
    const electricityServicesRef = useRef();
    const sanitationServicesRef = useRef();
    const maintenanceInfrastructureRef = useRef();
    const clientServiceCharterRef = useRef();
    const transportationNetworkServiceRef = useRef();
    const buildingInspectorateUnitRef = useRef();
    const permitProcessingIssuanceRef = useRef();
    const streetNamingRef = useRef();
    const socialProtectionServicesRef = useRef();
    const shelterTransactionalHousingRef = useRef();
    const districtHotlineNumberRef = useRef();
    const pwdServiceRef = useRef();
    const deepeningGenderMainstreamingRef = useRef();
    const nutritionInterventionRef = useRef();
    const sanitationServiceProvidersRef = useRef();
    const dumpingSiteRef = useRef();
    const foodVendorsRef = useRef();
    const publicSchoolFacilityRef = useRef();
    const climateChangeInterventionRef = useRef();
    const districtLEDActivityPlanRef = useRef();
    const businessAndJobPromotionRef = useRef();
    const agroProcessingFacilitySupportRef = useRef();
    const businessCommunityEngagementRef = useRef();
    const aapImplementationRef = useRef();
    const monitoringProjectAndActivityRef = useRef();
    const contractManagementAndAdminsRef = useRef();
    const followUpDeductionRef = useRef();
    const environmentalAndSocialSafeGuardRef = useRef();
    const capacityBuildingImplementationRef = useRef();
    const postTrainingEvaluationRef = useRef();
    const rateableRevenueRef = useRef();
    const auditCommitteeResponsivenessRef = useRef();
    const auditInfractionsRef = useRef();
    const educationServiceSupportRef = useRef();
    const healthServiceSupportRef = useRef();
    const agricultureSupportRef = useRef();
    const processedBulkSnapshotTokenRef = useRef(null);
    const [showPetition, setShowPetition] = useState(true);
    const currentUserRole = user?.user?.userRoles?.find(
        (role) => role.name === "DPAT TECHNICAL TEAM" || role.name === "DPAT QUALITY ASSURANCE" || role.name === "DPAT DISTRICT USERS" || role.name === "DPAT PETITION COMMITTEE"
    )?.name || "";
    const normalizedUserRole = currentUserRole ? currentUserRole.replace(/\s+/g, "_").toUpperCase() : "";
    const currentUsername = user?.user?.username || "";
    const currentFullName = user?.user?.fullName || "";

    const handlePrint = useReactToPrint({
        content: () => contentToPrint.current,
        documentTitle: `${district?.label}_DPAT_Score_Sheet_${reportYear ?? year}`,
        onBeforePrint: () => console.log("before printing..."),
        onAfterPrint: () => console.log("after printing..."),
        removeAfterPrint: true,
    });

    // Fetch assessment status on component mount
    useEffect(() => {
        let cancelled = false;
        const fetchAssessmentStatus = async () => {
            if (!districtOrgUnitId || reportYear == null) {
                setAssessmentStatus(null);
                setAssessmentStatusLoading(false);
                return;
            }
            setAssessmentStatusLoading(true);
            try {
                const response = await instance.get(
                    `assessments/dpat/${districtOrgUnitId}/${reportYear}/DPAT`
                );

                if (!cancelled) setAssessmentStatus(response.data);
            } catch (error) {
                console.error("Failed to fetch assessment status:", error);
                if (!cancelled) setAssessmentStatus(null);
            } finally {
                if (!cancelled) setAssessmentStatusLoading(false);
            }
        };

        fetchAssessmentStatus();
        return () => {
            cancelled = true;
        };
    }, [districtOrgUnitId, reportYear]);

    const isAssessmentStarted = useMemo(
        () => !bulkSnapshotMode && isDpatAssessmentLocked(assessmentStatus?.status),
        [assessmentStatus?.status, bulkSnapshotMode],
    );

    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (!isAssessmentStarted || !districtOrgUnitId || reportYear == null) {
                if (!cancelled) {
                    setAssessmentStartTables(null);
                    setAssessmentStartLoading(false);
                }
                return;
            }
            setAssessmentStartLoading(true);
            try {
                const tables = await fetchAssessmentStartTables(districtOrgUnitId, reportYear);
                if (!cancelled) setAssessmentStartTables(tables);
            } catch (error) {
                console.error("Failed to fetch assessment start snapshot:", error);
                if (!cancelled) setAssessmentStartTables(null);
            } finally {
                if (!cancelled) setAssessmentStartLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [districtOrgUnitId, reportYear, isAssessmentStarted]);

    const savedTables = useMemo(() => assessmentStartTables ?? {}, [assessmentStartTables]);

    const assessmentStartProps = useMemo(
        () => ({
            assessmentStartTables,
            assessmentStartLoading,
            isAssessmentStarted,
        }),
        [assessmentStartTables, assessmentStartLoading, isAssessmentStarted],
    );

    useEffect(() => {
        if (sheetAnnexMode === "full") setActiveAnnexPage(0);
    }, [sheetAnnexMode]);

    useEffect(() => {
        if (props?.pAndP) {
            setPAndP(props.pAndP);
        }
    }, [props?.pAndP]);

    useEffect(() => {
        if (isAssessmentStarted) {
            return;
        }
        setMeetingData();
        setDecisionData();
        setSubtructureEstablishmentsData();
        setSubStructureMeetingDataDisplay();
        setECAMeetingData();
        setManagementMeetingData();
        setPRCCMeetingData();
        setETCMeetingData();
        setMemberData();
        setMemberEcaCompositionData();
        setSubCommitteesCompositionData();
        setSubtructureActivities();
        setBuildingInspectoratesData();
        setStreetNamingDataDisplay();
        setAllDataFromDistrictGeneral();
        setAuditCommitteeDataDisplay();
        setSPCMeetingData();
        setInternalAuditCommitteeDataDisplay();
        subStructureExpenduture();
        setTransportorsDataDisplay();
        setSanitationServiceDataDisplay();
        setSocialServiceDataDisplay();
        setNutritionServiceDataDisplay();
        sanitationServiceData();
        setTownHallMeeting();
        setDeepeningGender();
        if (props?.documents?.data) {
            getAAPAndMTDPLinks();
        }
    }, [props, isAssessmentStarted, reportYear]);

    function formatData(meetings, meetingType) {
        return meetings.filter(item =>
            item.attributes.some(attr =>
                attr.displayName === "DPAT | Meeting Type" && attr.value === meetingType
            )
        );
    }

    function formatDataGeneral(data, property, value) {
        return data?.filter(item =>
            item.attributes.some(attr =>
                attr.displayName === property && attr.value === value
            )
        );
    }

    const getDaysBetween = (start, end) => {
        if (!start || !end) return "N/A";

        const startDate = new Date(start);
        const endDate = new Date(end);

        const diffTime = endDate - startDate; // Difference in milliseconds
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convert to days
    };

    const getAttributeValue = (key, val) => {
        const attr = val?.attributes.find(attr => attr.displayName === key);
        return attr ? attr.value : "N/A";
    };

    const setTownHallMeeting = () => {
        const reports = props.meetings.reports;
        const temp = [];

        setTowHallMeetingData(meetings);
        const townHallMeeting = formatData(meetings, "Town Hall Meetings") || [];
        let fulfillment = "Fulfilled";

        townHallMeeting.forEach((meeting, index) => {
            const minuteFileNumber = getAttributeValue("Minute File Number", meeting);
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);
            const meetingDataState = {
                key: index + 1,
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),

                invitationLetterReference: getAttributeValue("Invitation letter Ref. Number", meeting), // Invitation Letter Ref
                signatoryInvitationLetter: getAttributeValue("Who Signed the Invitation letter", meeting) === "PM" ?
                    "Presiding Member" : "Convener",
                minutes: minuteFileNumber,
                docs: minuteLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`
                    : "Not Uploaded",
                invitation: attendanceLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`
                    : "Not Uploaded",
                recommendation: recommendationLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`
                    : "Not Uploaded",
            };

            temp.push(meetingDataState);

            if (!minuteLink || !attendanceLink || !recommendationLink) {
                fulfillment = "Not Fulfilled";
            }
        });

        if (temp.length < 2) {
            fulfillment = "Not Fulfilled";
        }

        setTowHallMeetingData({ data: temp, fulfillment });
    };

    const setMeetingData = () => {
        const meetingList = props?.meetings?.meetings ?? meetings;
        const trackerDecisions = props?.decisions?.decisions ?? meetingDecisions;

        if (!meetingList?.length) {
            return;
        }

        const temp = [];
        let decisionNo = 0;
        let decisionOnServiceDeliveryNo = 0;
        const tempDecisions = [];
        const tempDecisionList = [];
        const serviceDeliveries = [];
        const reports = props?.meetings?.reports;

        formatData(meetingList, "GA").forEach((meeting, index) => {
            const meetingDate = getAttributeValue("DPAT | Meeting Date", meeting);
            if (getYearFromDateValue(meetingDate) !== Number(reportYear)) {
                return;
            }

            const minuteFileNumber = getAttributeValue("Minute File Number", meeting);
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const invitationLetterLink = getFileLinkIfExist(reports, "Vf1Fdd6ORkI", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const allowanceLink = getFileLinkIfExist(reports, "sZTHUWRoY7H", meeting.trackedEntity);
            const invitationSentLink = getFileLinkIfExist(reports, "m2p0PrrVHYn", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meeting: getMeetingRank(index, "GA"),
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                agenda: getAttributeValue("DPAT | Meeting Agenda", meeting),
                interval: 0,
                invitationLetterReference: getAttributeValue("Invitation letter Ref. Number", meeting),
                signatoryInvitationLetter: getAttributeValue("Who Signed the Invitation letter", meeting) === "PM" ?
                    "Presiding Member" : "Convener",
                signatoriesMinutes: minuteFileNumber,
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                invitationLetter: invitationLetterLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${invitationLetterLink}&dataElementUid=Vf1Fdd6ORkI`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded invitation letter"
                    >
                        View Letter
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                attendance: attendanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded attendance"
                    >
                        View Attendance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                invitationSent: invitationSentLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${invitationSentLink}&dataElementUid=m2p0PrrVHYn`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see invitation sent via WhatsApp or email"
                    >
                        View WA/Email
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                allowance: allowanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${allowanceLink}&dataElementUid=sZTHUWRoY7H`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded allowance"
                    >
                        View Allowance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
            };

            meetingDataState.interval = getDaysBetween(meetingDataState.invitationDate, meetingDataState.meetingDate);
            const decNo = getAttributeValue("DPAT | Number of Decisions", meeting);
            const decCount = parseOptionalCount(decNo);
            if (decCount != null) {
                decisionNo += decCount;
            }
            temp.push(meetingDataState);

            const serviceDeliveryDecion = getDecisionsByMeeting(trackerDecisions, minuteFileNumber);

            serviceDeliveryDecion?.forEach((s, decisionIndex) => {
                serviceDeliveries.push({
                    key: `${minuteFileNumber}-${decisionIndex}`,
                    decision: getAttributeValue("Decision", s),
                    action: getActionTakentByDecision(s.trackedEntity),
                    evidence: getDecisionEvidenceLink(s.trackedEntity),
                });
            });

            const serviceDeliveryNo = serviceDeliveryDecion ? serviceDeliveryDecion.length : 0;
            const decisionList = serviceDeliveryDecion
                ?.map((val, index) => `${index + 1}. ${getAttributeValue("Decision", val)}`)
                .join('<br/>');

            const gam = `${getMeetingRank(index, "GA")}  General Assembly Meeting`;

            const decisionServiceDelivery = {
                key: index + 1,
                gam: gam,
                total: decCount ?? decNo,
                serviceDecision: serviceDeliveryNo,
                percentage: decCount != null
                    ? Number(calcPercentage(serviceDeliveryNo, decCount).toFixed(2))
                    : 0,
            };

            decisionOnServiceDeliveryNo += serviceDeliveryNo;

            tempDecisions.push(decisionServiceDelivery);
            tempDecisionList.push({ key: index + 1, gam: gam, service: decisionList });
        });

        const finalTemp = temp.sort((a, b) => new Date(a.meetingDate) - new Date(b.meetingDate));

        finalTemp.forEach((m, index) => {
            m.meeting = getMeetingRank(index, "GA");
        });

        setGaMeetingData({
            meetings: finalTemp,
            fulfillment: checkGaMeetingFulfillment(temp),
            numberOfDecision: decisionNo
        });

        setDecisionServiceData(tempDecisions);
        setDecisionDeliveryData(tempDecisionList);
        setDecisionDeliveryListData(serviceDeliveries);
        getIndicatorsData(decisionOnServiceDeliveryNo, serviceDeliveries);
    };

    const countActionsTakenOnServiceDelivery = (serviceDeliveries = []) =>
        serviceDeliveries.filter(
            (item) => item.action && String(item.action).trim().length > 1,
        ).length;

    const getIndicatorsData = (decisionOnServiceDeliveryNo, serviceDeliveries = []) => {
        const trackerActionCount = countActionsTakenOnServiceDelivery(serviceDeliveries);

        const applyManagementData = (serviceCount) => {
            const percentage = calculatePercentage(decisionOnServiceDeliveryNo, serviceCount);
            setManagementActionServiceDeliveryData([
                { no: decisionOnServiceDeliveryNo, service: serviceCount, percentage },
            ]);
        };

        if (!decisionOnServiceDeliveryNo) {
            applyManagementData(0);
            return;
        }

        if (!districtOrgUnitId || reportYear == null) {
            applyManagementData(trackerActionCount);
            return;
        }

        axios.get(`/analytics.json?dimension=dx:y6pHogjYlez&dimension=ou:LEVEL-3;${districtOrgUnitId}&filter=pe:${reportYear}-01-01;${reportYear}-12-31`)
            .then(res => {
                const data = res.data?.rows;
                const analyticsCount = data?.length > 0 ? Number(data[0][2]) : NaN;
                const serviceCount = Number.isFinite(analyticsCount) && analyticsCount > 0
                    ? analyticsCount
                    : trackerActionCount;
                applyManagementData(serviceCount);
            })
            .catch(() => applyManagementData(trackerActionCount));
    };

    const getActionTakentByDecision = (trackedEntity) => {
        const decisionReports = props?.decisions?.reports;

        let actions = '';

        decisionReports?.forEach(d => {
            if (trackedEntity === d.trackedEntity) {
                const actionValue = d.dataValues?.find(
                    (dv) => dv.dataElement?.displayName?.toLowerCase().includes('action'),
                )?.value ?? d.dataValues?.[2]?.value;

                actions += actionValue || '';
            }
        });

        return actions.trim().length <= 1 ? '' : actions.trim();
    };

    const DECISION_EVIDENCE_DATA_ELEMENT = "hM6AUNKRbKB";

    const getDecisionEvidenceLink = (trackedEntity) => {
        const decisionReports = props?.decisions?.reports;
        const eventUid = getFileLinkIfExist(
            decisionReports,
            DECISION_EVIDENCE_DATA_ELEMENT,
            trackedEntity,
        );

        return eventUid
            ? `https://dddp.gov.gh/api/events/files?eventUid=${eventUid}&dataElementUid=${DECISION_EVIDENCE_DATA_ELEMENT}`
            : "Not Uploaded";
    };

    const calculatePercentage = (total, value) => {
        const totalNum = parseFloat(total);
        const valueNum = parseFloat(value);

        if (isNaN(totalNum) || isNaN(valueNum) || totalNum === 0) {
            return 0;
        }

        return ((valueNum / totalNum) * 100).toFixed(2);
    };

    const getDecisionMeetingReference = (decision) => {
        const referenceAttributes = [
            "DPAT | Meeting Reference Number",
            "DPAT | Meeting Reference",
            "Meeting reference number",
        ];

        for (const attributeName of referenceAttributes) {
            const value = getAttributeValue(attributeName, decision);
            if (value && value !== "N/A") {
                return String(value).trim();
            }
        }

        return "";
    };

    const getDecisionsByMeeting = (decisions, meetingReference) => {
        if (!decisions?.length || !meetingReference || meetingReference === "N/A") {
            return [];
        }

        const normalizedReference = String(meetingReference).trim();

        return decisions.filter((item) =>
            getDecisionMeetingReference(item) === normalizedReference,
        );
    };

    const getIgfAmountCollected = (record) => {
        const displayNames = ["Amount Collected", "Amt Collected", "DPAT | Amount Collected"];
        for (const name of displayNames) {
            const value = getAttributeValue(name, record);
            if (value && value !== "N/A") {
                return value;
            }
        }

        const matched = record?.attributes?.find((attr) => attr.attribute === "nlZbT98zSio");
        return matched?.value ?? "N/A";
    };

    const getPlanBudgetAllocated = (plan) => {
        const displayNames = [
            "Budget Allocated",
            "Budget Allocated(Ghana cedis)",
            "DPAT | Budget Allocated",
        ];
        for (const name of displayNames) {
            const value = getAttributeValue(name, plan);
            if (value && value !== "N/A") {
                return value;
            }
        }

        const matched = plan?.attributes?.find((attr) => attr.attribute === "mdO1ngv0Qt0");
        return matched?.value ?? "N/A";
    };

    const parseSanitationAmount = (value) => {
        if (value == null || value === "" || value === "N/A") {
            return 0;
        }

        const parsed = parseFloat(String(value).replace(/,/g, ""));
        return Number.isFinite(parsed) ? parsed : 0;
    };

    const setSanitationServiceDataDisplay = () => {
        const aap = props?.plans?.aap;
        const ifg = props?.ifg?.data;
        const sanitationPlan = formatDataGeneral(aap, "Sector", "Sanitation") || [];
        const sanitationPlans = isDpatScoreRelaxationExempt()
            ? filterRecordsByDpatYearAttribute(sanitationPlan, reportYear)
            : (formatDataGeneral(sanitationPlan, "Year", `${reportYear}`) || []);

        let totalBudget = 0;
        let totalIGF = 0;

        sanitationPlans?.forEach((plan) => {
            totalBudget += parseSanitationAmount(getPlanBudgetAllocated(plan));
        });

        ifg?.forEach((ig) => {
            totalIGF += parseSanitationAmount(getIgfAmountCollected(ig));
        });

        const percentage = Number(calculatePercentage(totalIGF, totalBudget));
        const sanitationData = {
            key: "sanitation-igf-expenditure",
            ifgCollected: totalIGF,
            igfSpentOnSanitation: totalBudget,
            percentage,
        };

        setSanitationProvidersData([sanitationData]);
    }

    const sanitationServiceData = () => {
        const temp = getAAPAndMTDPLinks("Sanitation");
        setSanitationServiceList(temp);
    }

    const getAAPAndMTDPLinks = (type = "default") => {
        const documents = props?.documents.data;
        const tempAAP = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Annual Action Plan Progress Report") || [];
        const tempMTDP = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Medium Term Development Plan (MTDP)") || [];

        const tempSaniationServiceProviders = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Sanitation Service Provider") || [];
        const reports = props?.documents.reports;


        let aapLink = "";
        let mtdpLink = "";
        let sspLink = "";

        if (tempSaniationServiceProviders.length > 0) {
            sspLink = getFileLinkIfExist(reports, "MjPmcbueEdU", tempSaniationServiceProviders[0]?.trackedEntity);
        }

        if (type !== "default") {
            return [
                {
                    title: "Sanitation Service Provider Report",
                    link: sspLink ? (
                        <a
                            className="px-2 text-primary fw-bold text-decoration-underline"
                            href={`https://dddp.gov.gh/api/events/files?eventUid=${sspLink}&dataElementUid=MjPmcbueEdU`} target="_blank"
                            rel="noopener noreferrer"
                            title="Click here to see the uploaded document"
                        >
                            View Report
                        </a>
                    ) : (
                        "Not Uploaded"
                    ),
                }]
        }

        if (tempAAP.length > 0) {
            aapLink = getFileLinkIfExist(reports, "MjPmcbueEdU", tempAAP[0]?.trackedEntity);
        }

        if (tempMTDP.length > 0) {
            mtdpLink = getFileLinkIfExist(reports, "MjPmcbueEdU", tempMTDP[0]?.trackedEntity);
        }

        const links = [
            {
                title: "Annual Action Plan Progress Report",
                link: aapLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${aapLink}&dataElementUid=MjPmcbueEdU`
                    : "Not Uploaded",
            },

            {
                title: "Meduim Term Development Plan Document",
                link: mtdpLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${mtdpLink}&dataElementUid=MjPmcbueEdU`
                    : "Not Uploaded",
            },
        ];

        setAapDocuments(links);

        return links;
    }

    const setDeepeningGender = () => {
        const documents = props?.documents.data;
        const tempAAP = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Annual Action Plan Progress Report") || [];
        const socialWelfare = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Social Welfare Progress Report") || [];
        const reports = props?.documents.reports;

        let aapLink = "";
        let swLink = "";

        if (tempAAP.length > 0) {
            aapLink = getFileLinkIfExist(reports, "MjPmcbueEdU", tempAAP[0]?.trackedEntity);
        }

        if (socialWelfare.length > 0) {
            swLink = getFileLinkIfExist(reports, "MjPmcbueEdU", socialWelfare[0]?.trackedEntity);
        }

        const links = [
            {
                title: "Annual Action Plan Progess Report",
                link: aapLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${aapLink}&dataElementUid=MjPmcbueEdU`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded Document"
                    >
                        View Report
                    </a>
                ) : (
                    "Not Uploaded"
                ),
            },

            {
                title: "Social Welfare Progress Report",
                link: swLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${swLink}&dataElementUid=MjPmcbueEdU`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded documents"
                    >
                        View Report
                    </a>
                ) : (
                    "Not Uploaded"
                ),
            },
        ];

        setDeepGenderData(links);

    }

    const setSocialServiceDataDisplay = () => {
        const aap = props.plans?.aap;
        const reports = props.plans?.reports;
        const publications = props.publications?.data;
        const socialServicePlans = formatDataGeneral(aap, "Activity Type", "Social Service") || [];
        const publicationOfSS = formatDataGeneral(publications, "Document Published", "Social Services") || [];
        const totalAap = aap?.length || 0;
        const totalSocialServicePlan = socialServicePlans.length;
        let totalSocialProtectionCompleted = 0;

        socialServicePlans?.forEach(plan => {
            const currentReport = reports.find(rep => rep.trackedEntity === plan.trackedEntity);

            if (currentReport) {
                currentReport.dataValues.forEach(rep => {
                    if (rep.dataElement === "SZcHb5mvjJx" && rep.value === "Completed") {
                        totalSocialProtectionCompleted++;
                    }
                });
            }
        });

        const percentage = calculatePercentage(totalSocialServicePlan, totalSocialProtectionCompleted);
        const planData = {
            aapTotal: totalAap,
            aapSocialProtection: totalSocialServicePlan,
            aapSocialProtectionImp: totalSocialProtectionCompleted,
            percentage
        };

        const tempPublication = [];

        if (publicationOfSS?.length > 0) {
            const date = getAttributeValue("Published Date", publicationOfSS[0]);
            const link = getAttributeValue("Website", publicationOfSS[0]);
            const tempData = {
                list: "YES",
                publication: link !== "N/A" ? "YES" : "NO",
                website: link,
                summary: `The list of the social services was published on the ${date}`
            };

            tempPublication.push(tempData);
        }

        setSocialServicesData({ aap: [planData], publication: tempPublication });

    }



    const setAllDataFromDistrictGeneral = () => {
        const hotline = [];
        let score = 0;

        if (districtGeneral?.length > 0) {
            const hotlineNumber = getAttributeValue("Public Hotline", districtGeneral[0]);
            hotline.push({
                hotline: hotlineNumber != "N/A" ? "YES" : "NO",
                number: hotlineNumber,
                publication: "YES"
            });

            if (hotlineNumber != "N/A") {
                score = 1;
            }
        }

        setDistrictHotlineNumberData({ data: hotline, score: score });
    };

    const BUILDING_INSPECTORATE_DATE_ATTRIBUTE = "YfoGKu8N6An";

    const getBuildingInspectorateDate = (building) => {
        const date = getAttributeValue("Date", building);
        if (date && date !== "N/A") {
            return date;
        }

        const matched = building?.attributes?.find(
            (attr) => attr.attribute === BUILDING_INSPECTORATE_DATE_ATTRIBUTE,
        );

        return matched?.value || "N/A";
    };

    const setBuildingInspectoratesData = () => {
        const temp = [];
        const inspectorates = props?.inspectorates?.inspectorates;

        formatDataGeneral(inspectorates, "DPAT | Inspectorate Type", "Planning and Building")
            ?.forEach((building) => {
                const rawDate = getBuildingInspectorateDate(building);
                if (!isDateInSelectedYear(rawDate, reportYear)) {
                    return;
                }

                const buildingInspectorateDateSet = {
                    key: building.trackedEntity || temp.length + 1,
                    date: formatTrackerDate(rawDate),
                    supervisor: getAttributeValue("Supervisor", building),
                    address: getAttributeValue("Address Location", building),
                    category: getAttributeValue("DPAT | Stakeholders Involved", building),
                    department: "None"
                };

                temp.push(buildingInspectorateDateSet);
            });

        setBuildingInspectorateData(temp);
    };

    const setTransportorsDataDisplay = () => {
        const temp = [];
        const trans = props?.transportors.data;
        trans?.forEach((tr, index) => {
            const registrationDateRaw = tr.createdAt || "";
            const transportDateSet = {
                key: index + 1,
                registrationDate: formatTrackerDate(registrationDateRaw),
                registrationDateRaw,
                createdAt: registrationDateRaw,
                business: getAttributeValue("Name of Business", tr),
                type: getAttributeValue("Transport Type", tr),
                typeVehicle: getAttributeValue("Type Vehicle", tr),
                vehicleQuantity: getAttributeValue("Quantity of Vehicles Owned", tr),
                noOfEmployee: getAttributeValue("Number of employees", tr)
            };

            temp.push(transportDateSet);
        });

        const transportationPlans = formatDataGeneral(props.plans?.aap, "Sector", "Roads and Transport") || [];

        const transp = {
            mtdp: transportationPlans.length > 0 ? "YES" : "NO",
            aapRoadsActivities: transportationPlans.length,
            aapRoadsActivitiesImp: 0,
            availability: temp.length > 0 ? "YES" : "NO"
        };

        // sow-djiba

        //get uploaded documents if exist(AAP and MTDP)
        const links = getAAPAndMTDPLinks();

        setTransportorsData({ data: transp, transportors: temp, links });
    }

    const setNutritionServiceDataDisplay = () => {
        const aap = props.plans?.aap;
        const publications = props.publications?.data;
        const publicationReport = props.publications?.reports;
        const publicationOfNS = formatDataGeneral(publications, "Document Published", "Nutrition Services") || [];
        const nutritionOrientedIntervention = formatDataGeneral(aap, "Activity Source", "Nutrition-Oriented Intervention Activity") || [];
        const foodVendors = props.foodVendors?.data;
        const foodTemp = [];

        foodVendors?.forEach(vendor => {
            const tempDataSet = {
                name: getAttributeValue("DCACT | Food Vendors - Name of vendor / Business", vendor),
                phone: getAttributeValue("Phone", vendor),
                tin: getAttributeValue("TIN", vendor),
                orientation: "YES"
            };

            foodTemp.push(tempDataSet);
        });

        const tempPublication = [];
        publicationOfNS.forEach((document, index) => {

            const reportLink = getFileLinkIfExist(publicationReport, "xjRCTFFiMA3", document.trackedEntity);

            const tempDataSet = {
                availability: reportLink ? "YES" : "NO",
                docReference: getAttributeValue("Document Reference ", document),
                channel: getAttributeValue("Publication Channel", document),
                webSiteLink: getAttributeValue("Website", document),
                document: reportLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${reportLink}&dataElementUid=xjRCTFFiMA3`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded document"
                    >
                        View Evidence
                    </a>
                ) : (
                    "Not Uploaded"
                ),
            };

            tempPublication.push(tempDataSet);


        });

        const temp = {
            aapTotal: aap?.length,
            aapNutrition: nutritionOrientedIntervention?.length,
            publication: publicationOfNS?.length > 0 ? "YES" : "NO"
        };

        setNutritionServcieData({ aap: [temp], vendors: foodTemp, publications: tempPublication });
    }

    const setSubStructureMeetingDataDisplay = () => {
        const temp = [];
        const reports = props.meetings.reports;
        const generalAssemblyMeeting = formatData(meetings, "GA") || [];
        const executiveCommitteeMeeting = formatData(meetings, "EC") || [];
        const subStructureMeeting = formatData(meetings, "Sub Structure Committee") || [];
        const subTemp = [];

        subStructureMeeting.forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const dataSet = {
                key: index,
                meeting: getAttributeValue("Sub Structure Having the meeting", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
            };

            subTemp.push(dataSet);
        });

        setEcMeetingTemp(subTemp);
        const formattedData = formatSubStructureMeetings(subTemp);

        temp.push(buildGroupedMeetingSummaryRow("General Assembly Meeting", generalAssemblyMeeting, reports));
        temp.push(buildGroupedMeetingSummaryRow("Executive Committee Meeting", executiveCommitteeMeeting, reports));

        let fulfillment = "Fulfilled";

        formattedData.forEach(item => {
            if (!allGroupedMeetingLinksUploaded(item)) {
                fulfillment = "Not Fulfilled";
            }
        });

        if (formattedData.length === 0) {
            fulfillment = "Not Fulfilled";
        }

        setSubStructuresMeetingData({ data: temp.concat(formattedData), fulfillment, subMeeting: formattedData });
    };

    const setStreetNamingDataDisplay = () => {
        const streets = props.streets.streets;
        const streetReport = props.streets.reports;
        let streetNo = streets?.length;
        let streetMapDisplayedAssemblyNo = 0;
        let streetMapDisplayedSubsNo = 0;
        let streetNamedNo = 0;
        let streetSignalInstalledNo = 0;

        if (streetNo > 0) {
            streetReport?.forEach(r => {
                r.dataValues.forEach(rep => {
                    if (rep.dataElement === "G67iyCp7yOr" && rep.value) {
                        streetNamedNo++;
                    } else if (rep.dataElement === "CWgnbQIpLnz" && rep.value) {
                        streetMapDisplayedAssemblyNo++;
                    } else if (rep.dataElement === "fSE6vasCbLa" && rep.value) {
                        streetMapDisplayedSubsNo++;
                    } else if (rep.dataElement === "DYW8oIgu2ld" && rep.value) {
                        streetSignalInstalledNo++;
                    }
                });
            });
        }

        const tempStreet = {
            street: streetNo > 0 ? "YES" : "NO",
            displayed: streetMapDisplayedAssemblyNo > 0 ? "YES" : "NO",
            map: streetMapDisplayedSubsNo > 0 ? "YES" : "NO"
        };

        const tempStreetCounter = {
            street: streetNo,
            streetNamedNo: streetNamedNo,
            streetNamedInstalled: streetSignalInstalledNo
        };

        const percentage = calculatePercentage(streetNamedNo, streetSignalInstalledNo);

        setStreetNamingData({ data: [tempStreet], counter: [tempStreetCounter], percentage });
    };

    function checkGaMeetingFulfillment(gaMeetings) {
        if (gaMeetings.length < 3) {
            return 'Not Fulfilled';
        }

        const linkKeys = ['invitationLetter', 'attendance', 'docs', 'allowance', 'invitationSent'];

        for (const mt of gaMeetings) {
            const isIntervalTooShort = mt.interval < 14;
            const missingFields =
                !mt.invitationLetterReference ||
                !mt.signatoriesMinutes ||
                !mt.signatoryInvitationLetter ||
                !rowHasAllEvidenceLinks(mt, linkKeys);

            if (isIntervalTooShort || missingFields) {
                return 'Not Fulfilled';
            }
        }

        return 'Fulfilled';
    }

    const setManagementMeetingData = () => {
        const temp = [];
        let fulfillment = 'Fulfilled';
        const reports = props.meetings.reports;

        const toOptionalCount = (value) => {
            if (value == null || value === "" || value === "N/A") return null;
            const parsed = parseInt(value, 10);
            return Number.isFinite(parsed) ? parsed : null;
        };

        const sumOptionalCounts = (...values) => {
            const counts = values.map(toOptionalCount);
            if (counts.every((count) => count == null)) return "";
            return counts.reduce((sum, count) => sum + (count ?? 0), 0);
        };

        formatData(meetings, "Management Meetings").forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const invitationLink = getFileLinkIfExist(reports, "Vf1Fdd6ORkI", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const hodAttendance = sumOptionalCounts(
                getAttributeValue("DPAT | Number of Participant - HoDs - Female", meeting),
                getAttributeValue("DPAT | Number of Participant - HoDs - Male", meeting),
            );

            const meetingDataState = {
                key: index + 1,
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                departments: 13,
                hodAttendance,
                attendance: sumOptionalCounts(
                    getAttributeValue("DPAT | Number of Attendance - Female", meeting),
                    getAttributeValue("DPAT | Number of Attendance - Male", meeting),
                ),
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`
                    : "Not Uploaded",
                invitation: invitationLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${invitationLink}&dataElementUid=Vf1Fdd6ORkI`
                    : "Not Uploaded",
                recommendation: recommendationLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`
                    : "Not Uploaded",
            };

            if ((hodAttendance !== "" && hodAttendance < 12) || !recommendationLink || !minuteLink || !invitationLink) {
                fulfillment = "Not Fulfilled";
            }

            temp.push(meetingDataState);
        });

        const finalTemp = temp.sort((a, b) => new Date(a.meetingDate) - new Date(b.meetingDate));

        finalTemp.forEach((m, index) => {
            m.meeting = getMeetingRank(index, "Management Meetings");
        });

        if (finalTemp.length === 0) {
            fulfillment = "Not Fulfilled";
        }

        setManagementMeetingsData({ data: finalTemp, fulfillment });
    };

    const setECAMeetingData = () => {
        const temp = [];
        const gaMeeting = formatData(meetings, "GA");
        const ecaMeeting = formatData(meetings, "EC");
        const reports = props.meetings.reports;

        const gaMeetingDates = gaMeeting.map((meeting, index) => ({
            key: index + 1,
            date: getAttributeValue("DPAT | Meeting Date", meeting),
        }));

        ecaMeeting.forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meeting: getMeetingRank(index, "EC"),
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                invitationLetterReference: getAttributeValue("Invitation letter Ref. Number", meeting),
                gaMeetingDate: gaMeetingDates[index]?.date || "",
                ecaMeetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                attendance: attendanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Attendance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                recommendation: recommendationLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Document
                    </a>
                ) : (
                    "Not Uploaded"
                )
            };

            temp.push(meetingDataState);
        });

        const fulfillment = checkECANDGAMeetingFulfillment(temp);
        setEcaMeetingData({ data: temp, fulfillment });
    };

    const setPRCCMeetingData = () => {
        const temp = [];
        let fulfillment = "Fulfilled";
        const reports = props.meetings.reports;

        formatData(meetings, "PRCC").forEach((meeting, index) => {
            const invitationLetterRef = getAttributeValue("Invitation letter Ref. Number", meeting);
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meeting: index + 1,
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                agenda: getAttributeValue("DPAT | Meeting Agenda", meeting),
                invitationLetterReference: invitationLetterRef,
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`
                    : "Not Uploaded",
                attendance: attendanceLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`
                    : "Not Uploaded",
                recommendation: recommendationLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`
                    : "Not Uploaded",
            };

            if (!minuteLink || !recommendationLink || !attendanceLink) {
                fulfillment = "Not Fulfilled";
            }

            temp.push(meetingDataState);
        });

        if (temp.length == 0) {
            fulfillment = "Not Fulfilled";
        }

        setPrccMeetingData({ data: temp, fulfillment: fulfillment });
    };

    const INTERNAL_AUDIT_REPORT_DATA_ELEMENT = "hM6AUNKRbKB";

    const setInternalAuditCommitteeDataDisplay = () => {
        const temp = [];
        let meetingFulfillment = "Fulfilled";
        let auditFulfillment = "Fulfilled";
        const reports = props.meetings.reports;
        formatData(meetings, "Audit Committee")?.forEach((meeting, index) => {
            const munitesRef = getAttributeValue("Minute File Number", meeting);
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                agenda: getAttributeValue("DPAT | Meeting Agenda", meeting),
                invitationDate: getAttributeValue("DPAT | Meeting Date", meeting),
                invitationLetterRef: getAttributeValue("Invitation letter Ref. Number", meeting),
                muniteRef: munitesRef,
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                attendance: attendanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded documented"
                    >
                        View Attendance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                recommendation: recommendationLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded document"
                    >
                        View Document
                    </a>
                ) : (
                    "Not Uploaded"
                )
            };

            if (!minuteLink || !attendanceLink || !recommendationLink) {
                meetingFulfillment = "Not Fulfilled";
            }

            temp.push(meetingDataState);
        });

        if (temp.length === 0) {
            meetingFulfillment = "Not Fulfilled";
        }

        const selectedYear = String(reportYear ?? year);
        const audits = (formatDataGeneral(props?.audits.data, "Audit Category", "Internal Audit") || [])
            .filter((audit) => {
                const yearAttr = audit?.attributes?.find((attr) => attr.attribute === "Ik7fouv4KOA");
                const yearValue = yearAttr?.value
                    || getAttributeValue("Select Year", audit)
                    || getAttributeValue("Select year", audit)
                    || getAttributeValue("Year", audit)
                    || getAttributeValue("Years", audit);

                if (isDpatScoreRelaxationExempt()) {
                    return isDpatIncidentYear(yearValue, selectedYear);
                }

                return String(yearValue) === selectedYear;
            });
        const auditReports = props?.audits?.reports || [];
        const auditTemp = [];

        audits.forEach((audit, index) => {
            const reportLink = getFileLinkIfExist(
                auditReports,
                INTERNAL_AUDIT_REPORT_DATA_ELEMENT,
                audit.trackedEntity,
            );

            auditTemp.push({
                key: index,
                no: index + 1,
                audit: getAttributeValue("Name", audit),
                report: reportLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${reportLink}&dataElementUid=${INTERNAL_AUDIT_REPORT_DATA_ELEMENT}`
                    : "Not Uploaded",
            });
        });

        if (auditTemp.length < 4 || !rowsHaveAllEvidenceLinks(auditTemp, ["report"])) {
            auditFulfillment = "Not Fulfilled";
        }

        const documents = props?.documents?.data;
        const documentReports = props?.documents?.reports;
        const internalAuditReportDocs = formatDataGeneral(
            documents,
            "DPAT | M&E Tool Type",
            "Internal Audit Report",
        ) || [];
        let internalAuditReportLink = "";

        if (internalAuditReportDocs.length > 0) {
            internalAuditReportLink = getFileLinkIfExist(
                documentReports,
                "MjPmcbueEdU",
                internalAuditReportDocs[0]?.trackedEntity,
            );
        }

        const links = [
            {
                title: "Internal Audit Report",
                link: internalAuditReportLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${internalAuditReportLink}&dataElementUid=MjPmcbueEdU`
                    : "Not Uploaded",
            },
        ];

        if (!documentHubLinksComplete(links)) {
            meetingFulfillment = "Not Fulfilled";
        }

        setInternalAuditMeetingData({ data: temp, fulfillment: meetingFulfillment, links });
        setInternalAuditData({ data: auditTemp, fulfillment: auditFulfillment });
    };

    const setAuditCommitteeDataDisplay = () => {
        const temp = [];
        let score = 0;

        const reports = props.meetings.reports;

        formatData(meetings, "Audit Committee").forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meeting: getMeetingRank(index, "Audit Committee"),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                recommendationsNo: getAttributeValue("DPAT | Number of Decisions", meeting),
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                attendance: attendanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Attendance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                recommendation: recommendationLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Document
                    </a>
                ) : (
                    "Not Uploaded"
                )
            };

            temp.push(meetingDataState);
        });

        if (temp.length > 1 && rowsHaveAllEvidenceLinks(temp, ["docs"])) {
            score = 3;
        }

        setAuditCommitteeMeetingData({ data: temp, score: score });
    };

    const setETCMeetingData = () => {
        const temp = [];
        let fulfillment = "Fulfilled";

        const reports = props.meetings.reports;

        formatData(meetings, "Spatial Planning Committee (SPC)").forEach((meeting, index) => {
            const munitesFileRef = getAttributeValue("Minute File Number", meeting);
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const allowanceLink = getFileLinkIfExist(reports, "sZTHUWRoY7H", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                agenda: getAttributeValue("DPAT | Meeting Agenda", meeting),
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                invitationLetterReference: munitesFileRef,
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`
                    : "Not Uploaded",
                attendance: attendanceLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`
                    : "Not Uploaded",
                recommendation: allowanceLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${allowanceLink}&dataElementUid=sZTHUWRoY7H`
                    : "Not Uploaded",
            };

            if (index < 12) {
                if (!attendanceLink || !minuteLink || !allowanceLink) {
                    fulfillment = "Not Fulfilled";
                }
            }


            temp.push(meetingDataState);
        });

        if (temp.length < 12) {
            fulfillment = "Not Fulfilled";
        }

        const monthsWithMeetings = new Set(
            temp.map(m => new Date(m.meetingDate).getMonth())
        );

        const allMonths = Array.from({ length: 12 }, (_, i) => i);
        const missingMonths = allMonths.filter(m => !monthsWithMeetings.has(m));

        if (missingMonths.length !== 0) {
            fulfillment = "Not Fulfilled";
        }

        const documents = props?.documents?.data;
        const documentReports = props?.documents?.reports;
        const workPlanDocs = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Work Plan") || [];
        let workPlanLink = "";

        if (workPlanDocs.length > 0) {
            workPlanLink = getFileLinkIfExist(
                documentReports,
                "MjPmcbueEdU",
                workPlanDocs[0]?.trackedEntity,
            );
        }

        const links = [
            {
                title: "Work Plan",
                link: workPlanLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${workPlanLink}&dataElementUid=MjPmcbueEdU`
                    : "Not Uploaded",
            },
        ];

        if (!documentHubLinksComplete(links)) {
            fulfillment = "Not Fulfilled";
        }

        setEtcMeetingData({ data: temp, fulfillment: fulfillment, links });
    };

    const setSPCMeetingData = () => {
        const temp = [];
        let fulfillment = "Fulfilled";
        const reports = props.meetings.reports;

        formatData(meetings, "Entity Tender Committee (ETC)").forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const attendanceLink = getFileLinkIfExist(reports, "brh8c5XO30Q", meeting.trackedEntity);
            const recommendationLink = getFileLinkIfExist(reports, "LLgjgXRMB5x", meeting.trackedEntity);

            const meetingDataState = {
                key: index + 1,
                meeting: "",
                invitationDate: getAttributeValue("Invitation letter Date", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                agenda: getAttributeValue("DPAT | Meeting Agenda", meeting),
                invitationLetterReference: getAttributeValue("Invitation letter Ref. Number", meeting),
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Minutes
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                attendance: attendanceLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${attendanceLink}&dataElementUid=brh8c5XO30Q`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded minutes"
                    >
                        View Attendance
                    </a>
                ) : (
                    "Not Uploaded"
                ),
                recommendation: recommendationLink ? (
                    <a
                        className="px-2 text-primary fw-bold text-decoration-underline"
                        href={`https://dddp.gov.gh/api/events/files?eventUid=${recommendationLink}&dataElementUid=LLgjgXRMB5x`} target="_blank"
                        rel="noopener noreferrer"
                        title="Click here to see the uploaded document"
                    >
                        View Document
                    </a>
                ) : (
                    "Not Uploaded"
                )
            };

            if (!minuteLink || !attendanceLink || !recommendationLink) {
                fulfillment = "Not Fulfilled";
            }

            temp.push(meetingDataState);
        });

        if (temp.length < 4) {
            fulfillment = "Not Fulfilled";
        }

        const finalTemp = temp.sort((a, b) => new Date(a.meetingDate) - new Date(b.meetingDate));

        finalTemp.forEach((m, index) => {
            m.meeting = getMeetingRank(index, "Entity Tender Committee (ETC)");
        });

        const documents = props?.documents?.data;
        const documentReports = props?.documents?.reports;
        const procurementPlanDocs = formatDataGeneral(documents, "DPAT | M&E Tool Type", "Procurement Plan") || [];
        let procurementPlanLink = "";

        if (procurementPlanDocs.length > 0) {
            procurementPlanLink = getFileLinkIfExist(
                documentReports,
                "MjPmcbueEdU",
                procurementPlanDocs[0]?.trackedEntity,
            );
        }

        const links = [
            {
                title: "Procurement Plan",
                link: procurementPlanLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${procurementPlanLink}&dataElementUid=MjPmcbueEdU`
                    : "Not Uploaded",
            },
        ];

        if (!documentHubLinksComplete(links)) {
            fulfillment = "Not Fulfilled";
        }

        setSpcMeetingData({ data: finalTemp, fulfillment: fulfillment, links });
    };

    const setDecisionData = () => {
        const meetingList = props?.meetings?.meetings ?? meetings;
        const trackerDecisions = props?.decisions?.decisions ?? meetingDecisions;

        if (!meetingList?.length || !trackerDecisions?.length) {
            return;
        }

        const temp = trackerDecisions
            .filter((d) =>
                d.attributes?.some(
                    (at) => at.displayName === "DPAT | Meeting Decision Type" && at.value === "GA",
                ),
            )
            .map((decision, index) => ({
                key: index + 1,
                gam: getDecisionRank(index),
                decision: decision.attributes?.find((attr) => attr.displayName === "Decision")?.value || "N/A",
                reference: getDecisionMeetingReference(decision),
            }));

        const finalTemp = meetingList.map((mt) => {
            const minuteFileNumber = String(getAttributeValue("Minute File Number", mt)).trim();
            return temp.find((t) => t.reference === minuteFileNumber);
        });

        setDecisionsData(finalTemp);
    };

    const subStructureExpenduture = () => {
        const reports = props?.districtGeneral.reports;
        const temp = [];
        reports?.forEach(re => {
            if (re.programStage === 'B0knjAzOqD4') {
                temp.push({
                    quarter: "",
                    amountReleased: re?.dataValues[0]?.value,
                    twoPercentReleased: re?.dataValues[3]?.value,
                    spentOnSubstructure: re?.dataValues[1]?.value,
                    percentageSpentSubstructure: re?.dataValues[2]?.value,
                });
            }
        });

        let score = 1;

        temp.forEach((t, idx) => {
            t.quarter = `Quarter  ${idx + 1}`;

            if (t.percentageSpentSubstructure < 90) {
                score = 0;
            }
        });

        setSubstructureExpendatureData({ data: temp, score });
    };

    const setSubtructureEstablishmentsData = () => {
        const temp = [];
        subStructures
            ?.forEach((sub, index) => {
                const subStructureDataState = {
                    key: index + 1,
                    name: getAttributeValue("DPAT | Name of Sub Structure", sub),
                    date: getAttributeValue("Established Date", sub),
                    category: getAttributeValue("DPAT | Sub Structure Committee", sub),
                };

                temp.push(subStructureDataState);
            });

        setSubStructureData(temp);

        const reportsTemp = [];
        let fulfillment = "Fulfilled";

        subReports?.filter(rep => rep.dataValues.length > 0)
            .forEach((report, index) => {
                const instance = subStructures.find(sub => sub.trackedEntity === report.trackedEntity);
                let collected = 0;
                let ceded = 0;
                let percentage = 0;
                report.dataValues.forEach(rep => {
                    if (rep.dataElement === "eINk68pU9p3" && rep.value) {
                        collected = parseFloat(rep.value);
                    } else if (rep.dataElement === "VFPyDBUtEwI" && rep.value) {
                        ceded = parseFloat(rep.value);
                    } else if (rep.dataElement === "j75xIlW2yV9" && rep.value) {
                        percentage = parseFloat(rep.value);
                    }
                });

                if (percentage < 50) {
                    fulfillment = "Not Fulfilled";
                }

                const minuteLink = getFileLinkIfExist(subReports, "TxE2hVHyNuG", instance.trackedEntity);

                if (!minuteLink) {
                    fulfillment = "Not Fulfilled";
                }

                reportsTemp.push({
                    key: index + 1,
                    name: getAttributeValue("DPAT | Name of Sub Structure", instance),
                    collected,
                    ceded,
                    percentage,
                    docs: minuteLink ? (
                        <a
                            className="px-2 text-primary fw-bold text-decoration-underline"
                            href={`https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=TxE2hVHyNuG`} target="_blank"
                            rel="noopener noreferrer"
                            title="Click here to see the uploaded evidence"
                        >
                            View Evidence
                        </a>
                    ) : (
                        "Not Uploaded"
                    ),
                });
            });

        setSubReportData({ data: reportsTemp, fulfillment });

        let collectedTotal = 0;
        let cededTotal = 0;
        let percentageTotal = 0;

        const finalRevenueDetails = [];

        reportsTemp.forEach(val => {
            finalRevenueDetails.push({
                name: val.name,
                collected: val.collected,
                ceded: val.ceded,
                percentage: val.percentage
            });

            collectedTotal += parseFloat(val.collected);
            cededTotal += parseFloat(val.ceded);
            percentageTotal += parseFloat(val.percentage);
        });

        finalRevenueDetails.push({
            name: <strong>Total</strong>,
            collected: <strong>{collectedTotal}</strong>,
            ceded: <strong>{cededTotal}</strong>,
            percentage: <strong>{calculatePercentage(collectedTotal, cededTotal)}</strong>
        });

        setCededRevenueUtilisationData(finalRevenueDetails);
        setCededRevenueUtilisationScore(calculatePercentage(collectedTotal, cededTotal));
    };

    const setSubtructureActivities = () => {
        const activityList = props?.subActivity?.activities ?? subStructureActivity;
        const activityReports = props?.subActivity?.reports;
        const SUB_ACTIVITY_EVIDENCE_DATA_ELEMENT = "TxE2hVHyNuG";
        const temp = [];

        activityList?.forEach((sub, index) => {
            const eventUid = getFileLinkIfExist(
                activityReports,
                SUB_ACTIVITY_EVIDENCE_DATA_ELEMENT,
                sub.trackedEntity,
            );

            const subStructureActivityDataState = {
                key: sub.trackedEntity || index + 1,
                no: index + 1,
                activities: getAttributeValue("Activity Description", sub),
                name: getAttributeValue("DPAT | Name of Sub Structure", sub),
                source: getAttributeValue("Activity Funding Source", sub),
                amount: getAttributeValue("Amount", sub),
                evidence: eventUid
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${eventUid}&dataElementUid=${SUB_ACTIVITY_EVIDENCE_DATA_ELEMENT}`
                    : "Not Uploaded",
            };

            temp.push(subStructureActivityDataState);
        });

        setSubStructureActivityData(temp);
    };

    const setMemberData = () => {
        const temp = [];
        members
            ?.forEach((member, index) => {
                const memberDataState = {
                    key: index + 1,
                    no: index + 1,
                    member: `${getAttributeValue("First Name", member)} ${getAttributeValue("Last Name", member)}`,
                    department: getAttributeValue("Staff Department", member),
                    appointment: getAttributeValue("DPAT |  Membership Status", member),
                };

                temp.push(memberDataState);
            });

        setMemberFinanceData(temp);
    };

    const setMemberEcaCompositionData = () => {
        const temp = [];

        formatDataGeneral(members, "DPAT | MMDA Unit", "Assembly Member")
            ?.forEach((member, index) => {
                const memberDataState = {
                    key: index + 1,
                    no: index + 1,
                    name: `${getAttributeValue("First Name", member)} ${getAttributeValue("Last Name", member)}`,
                    position: getAttributeValue("DPAT | Sub Structure Committee - Position", member),
                    sub: getAttributeValue("DPAT |  Statutory Sub Committee", member),
                };

                temp.push(memberDataState);
            });

        setEcaCompositionData(temp);
    };

    const setSubCommitteesCompositionData = () => {
        const statutoryMeetings = formatData(meetings, "Statutory Sub - Committee") || [];
        const tempMeeting = [];
        const reports = props.meetings.reports;

        statutoryMeetings.forEach((meeting, index) => {
            const minuteLink = getFileLinkIfExist(reports, "LAe1t59jYNT", meeting.trackedEntity);
            const meetingDataState = {
                key: index + 1,
                meeting: getAttributeValue("Sub Statutory Committee Department", meeting),
                meetingDate: getAttributeValue("DPAT | Meeting Date", meeting),
                minutes: getAttributeValue("Minute File Number", meeting),
                docs: minuteLink
                    ? `https://dddp.gov.gh/api/events/files?eventUid=${minuteLink}&dataElementUid=LAe1t59jYNT`
                    : "Not Uploaded",
            };
            tempMeeting.push(meetingDataState);
        });

        let fulfillment = "Fulfilled";

        if (tempMeeting.length < 15) {
            fulfillment = "Not Fulfilled";
        }

        const formattedData = formatSubStatutoryMeetings(tempMeeting);

        const ecMeetings = formatData(meetings, "EC") || [];
        const ecMeetingDates = {
            firstMeeting: getAttributeValue("DPAT | Meeting Date", ecMeetings[0]) || null,
            secondMeeting: getAttributeValue("DPAT | Meeting Date", ecMeetings[1]) || null,
            thirdMeeting: getAttributeValue("DPAT | Meeting Date", ecMeetings[2]) || null,
        };

        if (!allStatutorySubCommitteeRowsComplete(formattedData)) {
            fulfillment = "Not Fulfilled";
        }

        setSubStatutoryData({ data: formattedData, fulfillment: fulfillment, ecMeetingDates });
    };


    const getDecisionRank = (index) => {
        switch (index) {
            case 0: return "1st";
            case 1: return "2nd";
            case 2: return "3rd";
            default: return "Other";
        }
    };

    const assessmentStartDate = new Date().toISOString().split("T")[0].split("-").map(Number);


    const handleStartAssessmentSubmit = async () => {
        setProgressLoad(true);
        const payload = {
            id: 0,
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            userRole: normalizedUserRole,
            type: "DPAT",
            districtId: districtOrgUnitId,
            year: year,
            status: "Start",
            assessmentStartDate: assessmentStartDate,
            assessmentEndDate: null,
            reviewStartDate: null,
            reviewEndDate: null,
            closedDate: null,
        };

        const dddpData = {
            gaMeeting: gaMeetingRef.current?.getData(),
            aapBudgetApproval: aapBudgetApprovalRef.current?.getData(),
            subStructureMeeting: subStructureMeetingRef.current?.getData(),
            executiveCommitteeMember: executiveCommitteeMemberRef.current?.getData(),
            subStructureCommitteeMeeting: subStructureCommitteeMeetingRef.current?.getData(),
            managementMeeting: managementMeetingRef.current?.getData(),
            prccMeeting: prccMeetingRef.current?.getData(),
            entityTenderCommitteeMeeting: entityTenderCommitteeMeetingRef.current?.getData(),
            spcEntityTenderCommittee: spcEntityTenderCommitteeRef.current?.getData(),
            internalAuditUnitFunctionality: internalAuditUnitFunctionalityRef.current?.getData(),
            auditCommitteeMeeting: auditCommitteeMeetingRef.current?.getData(),
            clientServiceFunctionality: clientServiceFunctionalityRef.current?.getData(),
            aapPublication: aapPublicationRef.current?.getData(),
            auditorGeneralGAMeeting: auditorGeneralGAMeetingRef.current?.getData(),
            townHallMeeting: townHallMeetingRef.current?.getData(),
            generalAssemblyDecision: generalAssemblyDecisionRef.current?.getData(),
            generalAssemblyManagementActions: generalAssemblyManagementActionsRef.current?.getData(),
            gaSupport: gaSupportRef.current?.getData(),
            waterServices: waterServicesRef.current?.getData(),
            electricityServices: electricityServicesRef.current?.getData(),
            sanitationServices: sanitationServicesRef.current?.getData(),
            maintenanceInfrastructure: maintenanceInfrastructureRef.current?.getData(),
            clientServiceCharter: clientServiceCharterRef.current?.getData(),
            transportationNetworkService: transportationNetworkServiceRef.current?.getData(),
            buildingInspectorateUnit: buildingInspectorateUnitRef.current?.getData(),
            permitProcessingIssuance: permitProcessingIssuanceRef.current?.getData(),
            streetNaming: streetNamingRef.current?.getData(),
            socialProtectionServices: socialProtectionServicesRef.current?.getData(),
            shelterTransactionalHousing: shelterTransactionalHousingRef.current?.getData(),
            districtHotlineNumber: districtHotlineNumberRef.current?.getData(),
            pwdService: pwdServiceRef.current?.getData(),
            deepeningGenderMainstreaming: deepeningGenderMainstreamingRef.current?.getData(),
            nutritionIntervention: nutritionInterventionRef.current?.getData(),
            sanitationServiceProviders: sanitationServiceProvidersRef.current?.getData(),
            dumpingSite: dumpingSiteRef.current?.getData(),
            foodVendors: foodVendorsRef.current?.getData(),
            publicSchoolFacility: publicSchoolFacilityRef.current?.getData(),
            climateChangeIntervention: climateChangeInterventionRef.current?.getData(),
            districtLEDActivityPlan: districtLEDActivityPlanRef.current?.getData(),
            businessAndJobPromotion: businessAndJobPromotionRef.current?.getData(),
            agroProcessingFacilitySupport: agroProcessingFacilitySupportRef.current?.getData(),
            businessCommunityEngagement: businessCommunityEngagementRef.current?.getData(),
            aapImplementation: aapImplementationRef.current?.getData(),
            monitoringProjectAndActivity: monitoringProjectAndActivityRef.current?.getData(),
            contractManagementAndAdmins: contractManagementAndAdminsRef.current?.getData(),
            followUpDeduction: followUpDeductionRef.current?.getData(),
            environmentalAndSocialSafeGuard: environmentalAndSocialSafeGuardRef.current?.getData(),
            capacityBuildingImplementation: capacityBuildingImplementationRef.current?.getData(),
            postTrainingEvaluation: postTrainingEvaluationRef.current?.getData(),
            rateableRevenue: rateableRevenueRef.current?.getData(),
            auditCommitteeResponsiveness: auditCommitteeResponsivenessRef.current?.getData(),
            auditInfractions: auditInfractionsRef.current?.getData(),
            educationServiceSupport: educationServiceSupportRef.current?.getData(),
            healthServiceSupport: healthServiceSupportRef.current?.getData(),
            agricultureSupport: agricultureSupportRef.current?.getData(),
        };

        const calibratedTables = dddpData;

        try {
            // Step 1: Post to assessments endpoint
            const assessmentResponse = await instance.post(`assessments`, payload);
            setAssessmentStatus(assessmentResponse.data);
            message.success({
                content: (
                    <div>
                        <p>Assessment started successfully</p>
                    </div>
                ),
                duration: 3,
            });

            const fetchedStatus = assessmentResponse.data?.status;
            setAssessmentStatus(assessmentResponse.data);

            // Step 2: Post to comments endpoint
            const commentDate = new Date().toISOString().split("T")[0];
            const commentPayload = {
                id: 0,
                username: user?.user?.username,
                fullName: user?.user?.fullName,
                userRole: normalizedUserRole,
                type: "DPAT",
                districtId: districtOrgUnitId,
                year: year,
                tableCommented: "assessment_start_DAPT",
                comments: `Assessment started automatically with status: ${fetchedStatus || "Start"}`,
                gaps: "",
                commentDate: commentDate,
                updateDate: commentDate,
                dddpDataDate: commentDate,
                dddpData: {
                    indicator: "assessment_start_DAPT",
                    tables: calibratedTables
                },
            };

            createCommentMutation.mutate(commentPayload, {
                onSuccess: async () => {
                    try {
                        const tables = await fetchAssessmentStartTables(
                            districtOrgUnitId,
                            reportYear ?? year,
                        );
                        setAssessmentStartTables(tables);
                    } catch (error) {
                        console.error("Failed to refresh assessment start snapshot:", error);
                    }
                    message.success({
                        content: (
                            <div>
                                <p>Assessment started. Reloading sheet data for this district and year…</p>
                            </div>
                        ),
                        duration: 3,
                    });
                },
                onError: (error) => {
                    console.error("Failed to create comment for assessment start:", {
                        message: error.message,
                        response: error.response?.data,
                        status: error.response?.status,
                    });
                }
            });

        } catch (error) {
            console.error("Failed to process assessment or comment:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to process: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };

    useEffect(() => {
        onBulkSnapshotCollectorReady?.();
    }, [onBulkSnapshotCollectorReady]);

    useEffect(() => {
        const token = bulkSnapshotRequest?.token;
        if (!token || processedBulkSnapshotTokenRef.current === token) return;
        processedBulkSnapshotTokenRef.current = token;

        const captureBulkSnapshot = async () => {
            try {
                const tables = collectDpatAssessmentTables({
                    gaMeeting: gaMeetingRef,
                    aapBudgetApproval: aapBudgetApprovalRef,
                    subStructureMeeting: subStructureMeetingRef,
                    executiveCommitteeMember: executiveCommitteeMemberRef,
                    subStructureCommitteeMeeting: subStructureCommitteeMeetingRef,
                    managementMeeting: managementMeetingRef,
                    prccMeeting: prccMeetingRef,
                    entityTenderCommitteeMeeting: entityTenderCommitteeMeetingRef,
                    spcEntityTenderCommittee: spcEntityTenderCommitteeRef,
                    internalAuditUnitFunctionality: internalAuditUnitFunctionalityRef,
                    auditCommitteeMeeting: auditCommitteeMeetingRef,
                    clientServiceFunctionality: clientServiceFunctionalityRef,
                    aapPublication: aapPublicationRef,
                    auditorGeneralGAMeeting: auditorGeneralGAMeetingRef,
                    townHallMeeting: townHallMeetingRef,
                    generalAssemblyDecision: generalAssemblyDecisionRef,
                    generalAssemblyManagementActions: generalAssemblyManagementActionsRef,
                    gaSupport: gaSupportRef,
                    waterServices: waterServicesRef,
                    electricityServices: electricityServicesRef,
                    sanitationServices: sanitationServicesRef,
                    maintenanceInfrastructure: maintenanceInfrastructureRef,
                    clientServiceCharter: clientServiceCharterRef,
                    transportationNetworkService: transportationNetworkServiceRef,
                    buildingInspectorateUnit: buildingInspectorateUnitRef,
                    permitProcessingIssuance: permitProcessingIssuanceRef,
                    streetNaming: streetNamingRef,
                    socialProtectionServices: socialProtectionServicesRef,
                    shelterTransactionalHousing: shelterTransactionalHousingRef,
                    districtHotlineNumber: districtHotlineNumberRef,
                    pwdService: pwdServiceRef,
                    deepeningGenderMainstreaming: deepeningGenderMainstreamingRef,
                    nutritionIntervention: nutritionInterventionRef,
                    sanitationServiceProviders: sanitationServiceProvidersRef,
                    dumpingSite: dumpingSiteRef,
                    foodVendors: foodVendorsRef,
                    publicSchoolFacility: publicSchoolFacilityRef,
                    climateChangeIntervention: climateChangeInterventionRef,
                    districtLEDActivityPlan: districtLEDActivityPlanRef,
                    businessAndJobPromotion: businessAndJobPromotionRef,
                    agroProcessingFacilitySupport: agroProcessingFacilitySupportRef,
                    businessCommunityEngagement: businessCommunityEngagementRef,
                    aapImplementation: aapImplementationRef,
                    monitoringProjectAndActivity: monitoringProjectAndActivityRef,
                    contractManagementAndAdmins: contractManagementAndAdminsRef,
                    followUpDeduction: followUpDeductionRef,
                    environmentalAndSocialSafeGuard: environmentalAndSocialSafeGuardRef,
                    capacityBuildingImplementation: capacityBuildingImplementationRef,
                    postTrainingEvaluation: postTrainingEvaluationRef,
                    rateableRevenue: rateableRevenueRef,
                    auditCommitteeResponsiveness: auditCommitteeResponsivenessRef,
                    auditInfractions: auditInfractionsRef,
                    educationServiceSupport: educationServiceSupportRef,
                    healthServiceSupport: healthServiceSupportRef,
                    agricultureSupport: agricultureSupportRef,
                });
                const populatedTableCount = Object.values(tables).filter(Boolean).length;
                if (populatedTableCount < 52) {
                    throw new Error(
                        `Assessment indicators are not ready (${populatedTableCount} of 52 loaded).`,
                    );
                }

                const calibratedTables = tables;
                onBulkSnapshotReady?.({
                    token,
                    districtId: districtOrgUnitId,
                    tables: calibratedTables,
                });
            } catch (error) {
                onBulkSnapshotError?.({ token, districtId: districtOrgUnitId, error });
            }
        };

        captureBulkSnapshot();
    }, [
        bulkSnapshotRequest,
        district,
        districtOrgUnitId,
        onBulkSnapshotError,
        onBulkSnapshotReady,
        reportYear,
        year,
    ]);

    const handlePendingAssessmentSubmit = async () => {
        setProgressLoad(true);
        const assessmentEndDate = new Date().toISOString().split("T")[0];
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today

        // Ensure assessmentStatus has an ID
        if (!assessmentStatus?.id) {
            message.error("No assessment ID found. Please start the assessment first.");
            setProgressLoad(false);
            return;
        }

        const payload = {
            id: assessmentStatus.id, // Use dynamic ID from assessmentStatus
            username: user?.user?.username,
            fullName: user?.user?.fullName,
            reviewedBy: assessmentStatus?.reviewedBy || user?.user?.username, // Use existing reviewed by or fallback to current user
            userRole: normalizedUserRole,
            type: assessmentStatus?.type || "DPAT",
            districtId: districtOrgUnitId,
            year: year,
            status: "Pending",
            assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentEndDate,
            reviewEndDate: null,
            closedDate: null,
        };

        try {
            // Step 1: Update assessment with PUT request
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>Assessment completed successfully</p>
                    </div>
                ),
                duration: 3,
            });

        } catch (error) {
            console.error("Failed to complete assessment or comment:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to complete assessment: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };

    const handleCompleteReviewSubmit = async () => {
        setProgressLoad(true);
        const reviewEndDate = new Date().toISOString().split("T")[0];
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0];
        const assessmentEndDate = assessmentStatus?.assessmentEndDate || new Date().toISOString().split("T")[0];

        if (!assessmentStatus?.id) {
            message.error("No assessment ID found. Please start the assessment first.");
            setProgressLoad(false);
            return;
        }

        const payload = {
            id: assessmentStatus.id,
            username: assessmentStatus?.username || user?.user?.username,
            fullName: assessmentStatus?.fullName || user?.user?.fullName,
            userRole: assessmentStatus?.userRole || "DAQ",
            reviewedBy: assessmentStatus?.reviewedBy || user?.user?.username,
            completedBy: assessmentStatus?.completedBy || user?.user?.username,
            type: assessmentStatus?.type || "DPAT",
            districtId: districtOrgUnitId,
            year: year,
            status: "Reviewed",
            assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate,
            reviewEndDate: reviewEndDate,
            closedDate: null,
        };

        try {
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>QA review completed. Assessment is ready for dashboard release to the district.</p>
                    </div>
                ),
                duration: 3,
            });
        } catch (error) {
            console.error("Failed to complete review or comment:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to complete review: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };

    const handleCloseReviewSubmit = async () => {
        setProgressLoad(true);
        const reviewEndDate = new Date().toISOString().split("T")[0];
        const assessmentStartDate = assessmentStatus?.assessmentStartDate || new Date().toISOString().split("T")[0]; // Use existing start date or fallback to today
        const assessmentEndDate = assessmentStatus?.assessmentEndDate || new Date().toISOString().split("T")[0]; // Use existing end date or fallback to today
        const reviewCloseDate = new Date().toISOString().split("T")[0];

        // Ensure assessmentStatus has an ID
        if (!assessmentStatus?.id) {
            message.error("No assessment ID found. Please start the assessment first.");
            setProgressLoad(false);
            return;
        }

        const payload = {
            id: assessmentStatus.id, // Use dynamic ID from assessmentStatus
            username: assessmentStatus?.username || user?.user?.username, // Use existing username or fallback to current user
            fullName: assessmentStatus?.fullName || user?.user?.fullName, // Use existing full name or fallback to current user
            completedBy: assessmentStatus?.completedBy || user?.user?.username, // Use existing completed by or fallback to current user
            closedBy: assessmentStatus?.closedBy || user?.user?.username, // Use existing closed by or fallback to current user
            userRole: assessmentStatus?.userRole || "DAQ",
            type: assessmentStatus?.type || "DPAT",
            districtId: districtOrgUnitId,
            year: year,
            status: "Closed",
            assessmentStartDate: assessmentStartDate,
            assessmentEndDate: assessmentEndDate,
            reviewStartDate: assessmentStatus?.reviewStartDate || assessmentEndDate, // Use existing review start date or fallback to assessmentEndDate
            reviewEndDate: reviewEndDate,
            closedDate: reviewCloseDate,
        };

        try {
            // Step 1: Update assessment with PUT request
            const response = await instance.put(`assessments/${payload.id}`, payload);
            setAssessmentStatus(response.data);
            message.success({
                content: (
                    <div>
                        <p>Review completed successfully</p>
                    </div>
                ),
                duration: 3,
            });

            setAssessmentStatus(response.data); // Update state with the fetched assessment data

        } catch (error) {
            console.error("Failed to complete review or comment:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
            message.error(`Failed to complete review: ${error.response?.data?.message || error.message}`);
        } finally {
            setProgressLoad(false);
        }
    };
    const hideComment = !isAssessmentStarted;
    const shouldRenderQualityAssuranceEditor1 = !assessmentStatus || assessmentStatus?.status === "Start" || assessmentStatus?.status === "Pending";
    const hideRoleScoreColumnsForDistrictUser = isDpatDistrictRestrictedViewer(user);
    const canViewScoreSheets = canViewDpatScoreSheets(user);
    const showScoreSheetsAtTop = canViewScoreSheets;
    const showScoreSheetsInAnnex4 = false;
    const showConfirm = () => {
        Modal.confirm({
            title: 'Start Assessment',
            content: `Do you want to start the ${reportYear} assessment for this district ?`,
            okText: 'Yes',
            cancelText: 'No',

            onOk() {
                handleStartAssessmentSubmit(); // Trigger the original endpoint call
            },
            onCancel() {
                // Do nothing on cancel
            },
        });
    };

    const showPending = () => {
        Modal.confirm({
            title: 'Complete Assessment',
            content: `Do you want to Complete ${reportYear} assessment for this district ?`,
            okText: 'Yes',
            cancelText: 'No',

            onOk() {
                handlePendingAssessmentSubmit(); // Trigger the original endpoint call
            },
            onCancel() {
                // Do nothing on cancel
            },
        });
    };

    const showComplete = () => {
        Modal.confirm({
            title: "Complete QA Review",
            content: `Do you want to complete QA review for the ${reportYear} assessment? This marks it as Reviewed and ready for dashboard release to the district.`,
            okText: "Yes",
            cancelText: "No",

            onOk() {
                handleCompleteReviewSubmit();
            },
            onCancel() {
                // Do nothing on cancel
            },
        });
    };

    const showClose = (context = "default") => {
        const isAfterResponse = context === "afterResponse";
        Modal.confirm({
            title: isAfterResponse ? "Close assessment" : "Close Review",
            content: isAfterResponse
                ? `You have submitted the committee response. Do you want to close the ${reportYear} assessment for this district and complete the workflow?`
                : `Do you want to Close ${reportYear} Review for this district?`,
            okText: "Yes, close assessment",
            cancelText: "Not now",

            onOk() {
                handleCloseReviewSubmit();
            },
            onCancel() {
                // Do nothing on cancel
            },
        });
    };

    const hideStaticDpatContent =
        reportYear != null &&
        !cmsYearSetupLoading &&
        cmsYearSetupError == null &&
        cmsYearSetupEmpty;

    const dpatWorkflowBanner = useMemo(() => {
        const loadingTheme = {
            background: "#f8fafc",
            border: "#e2e8f0",
            accent: "#94a3b8",
            title: "#334155",
            subtitle: "#64748b",
        };
        const notStartedTheme = {
            background: "#f8fafc",
            border: "#e2e8f0",
            accent: "#64748b",
            title: "#1f2937",
            subtitle: "#475569",
        };

        if (assessmentStatusLoading) {
            return {
                state: "loading",
                statusLabel: null,
                message: "Please wait while we load the assessment workflow for this district and year.",
                theme: loadingTheme,
            };
        }

        const status = assessmentStatus?.status;
        if (!status) {
            return {
                state: "not_started",
                statusLabel: "Not started",
                message: "Load tracker data and CMS indicators to continue the DPAT workflow.",
                theme: notStartedTheme,
            };
        }

        const statusKey = String(status).toLowerCase();
        const themeByStatus = {
            start: {
                background: "#eff6ff",
                border: "#dbeafe",
                accent: "#3b82f6",
                title: "#1e3a8a",
                subtitle: "#334155",
            },
            pending: {
                background: "#fff7ed",
                border: "#ffedd5",
                accent: "#f59e0b",
                title: "#92400e",
                subtitle: "#7c2d12",
            },
            reviewed: {
                background: "#eef2ff",
                border: "#c7d2fe",
                accent: "#4f46e5",
                title: "#312e81",
                subtitle: "#3730a3",
            },
            completed: {
                background: "#f1f8eb",
                border: "#d8e7cc",
                accent: "#52c41a",
                title: "#2f4f23",
                subtitle: "#344b2c",
            },
            closed: {
                background: "#f1f8eb",
                border: "#d8e7cc",
                accent: "#52c41a",
                title: "#2f4f23",
                subtitle: "#344b2c",
            },
        };

        const messageByStatus = {
            start: "Assessment is in progress. District teams capture evidence; technical team coordinates scores and comments.",
            pending: "Assessment is with Quality Assurance for review and sign-off.",
            reviewed: "QA review is complete. Waiting for dashboard release to the district.",
            completed: "Assessment has been released to the district; petition steps may follow where applicable.",
            closed: "This assessment cycle has been closed.",
        };

        return {
            state: "known",
            statusLabel: status,
            message: messageByStatus[statusKey] || "Assessment workflow is active for this district and year.",
            theme: themeByStatus[statusKey] || notStartedTheme,
        };
    }, [assessmentStatusLoading, assessmentStatus]);

    const assessmentDateDisplay = useMemo(
        () => getDpatAssessmentDateDisplay(assessmentStatus),
        [assessmentStatus]
    );

    const annexNavProps = useMemo(
        () => ({
            activeIndex: activeAnnexPage,
            total: DPAT_ANNEX_COUNT,
            labels: DPAT_ANNEX_LABELS,
            sheetAnnexMode,
            onSetFullMode: () => setSheetAnnexMode("full"),
            onSetAnnexMode: () => setSheetAnnexMode("annex"),
            onPrevious: () => setActiveAnnexPage((p) => Math.max(0, p - 1)),
            onNext: () => setActiveAnnexPage((p) => Math.min(DPAT_ANNEX_COUNT - 1, p + 1)),
        }),
        [sheetAnnexMode, activeAnnexPage],
    );

    const annexModeToolbarEl = useMemo(
        () => <DpatAnnexNavigator section="mode" {...annexNavProps} />,
        [annexNavProps],
    );

    const annexStepsNavEl = useMemo(
        () => <DpatAnnexNavigator section="steps" {...annexNavProps} />,
        [annexNavProps],
    );

    return (
        <DpatDocumentViewerProvider>
            <DpatCommentFeedbackProvider
                assessmentStatus={assessmentStatus}
                districtId={districtOrgUnitId}
                year={reportYear ?? year}
                assessmentStartTables={assessmentStartTables}
            >
            <div className="min-h-full bg-background">
                <div className="space-y-1 p-1 md:p-0">
                    <Space direction="vertical" size={12} style={{ width: "100%" }}>
                        {reportYear != null && cmsYearSetupLoading && (
                            <Alert type="info" showIcon message="Checking DPAT indicator configuration for this year…" />
                        )}
                        {cmsYearSetupError && (
                            <Alert
                                type="error"
                                showIcon
                                message="DPAT CMS indicator check failed"
                                description={cmsYearSetupError}
                            />
                        )}
                        {reportYear != null && !cmsYearSetupLoading && cmsYearSetupEmpty && (
                            <Alert
                                type="warning"
                                showIcon
                                message={`There is no DPAT indicators setup for ${reportYear}. Please contact the administrator to set up the DPAT indicators for this year so that you can proceed with the assessment process.`}
                            />
                        )}
                    </Space>
                    {!hideStaticDpatContent && (
                        <Row style={{ marginBottom: 1 }} gutter={[16, 12]}>
                            <Col span={24}>
                                <div
                                    style={{
                                        borderRadius: 8,
                                        padding: "12px 14px",
                                        background: dpatWorkflowBanner.theme.background,
                                        border: `1px solid ${dpatWorkflowBanner.theme.border}`,
                                        borderLeft: `4px solid ${dpatWorkflowBanner.theme.accent}`,
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "flex-start", gap: 10, minWidth: 0 }}>
                                        {dpatWorkflowBanner.state === "loading" ? (
                                            <Spin
                                                indicator={<LoadingOutlined style={{ fontSize: 18, color: dpatWorkflowBanner.theme.accent }} spin />}
                                                style={{ marginTop: 2 }}
                                            />
                                        ) : (
                                            <CheckCircleOutlined
                                                style={{ color: dpatWorkflowBanner.theme.accent, fontSize: 18, marginTop: 2 }}
                                            />
                                        )}
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            <p
                                                style={{
                                                    margin: 0,
                                                    color: dpatWorkflowBanner.theme.title,
                                                    fontSize: 18,
                                                    fontWeight: 500,
                                                    lineHeight: 1.25,
                                                }}
                                            >
                                                {dpatWorkflowBanner.state === "loading"
                                                    ? "Checking assessment status…"
                                                    : `Assessment status: ${dpatWorkflowBanner.statusLabel}`}
                                            </p>
                                            <p
                                                style={{
                                                    margin: "4px 0 0",
                                                    color: dpatWorkflowBanner.theme.subtitle,
                                                    fontSize: 13,
                                                    lineHeight: 1.4,
                                                }}
                                            >
                                                {dpatWorkflowBanner.message}
                                            </p>
                                            {dpatWorkflowBanner.state === "loading" && (
                                                <div
                                                    style={{
                                                        marginTop: 10,
                                                        height: 6,
                                                        borderRadius: 4,
                                                        background: "#e2e8f0",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <div
                                                        className="dpat-workflow-status-skeleton"
                                                        style={{
                                                            height: "100%",
                                                            width: "40%",
                                                            borderRadius: 4,
                                                            background: "linear-gradient(90deg, #cbd5e1 0%, #e2e8f0 50%, #cbd5e1 100%)",
                                                            backgroundSize: "200% 100%",
                                                            animation: "dpatWorkflowSkeleton 1.2s ease-in-out infinite",
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}


                    {!hideStaticDpatContent ? (
                        <>

                            <Col span={10} className="gutter-row">

                                {!assessmentStatusLoading && !assessmentStatus &&
                                    user?.user?.userRoles?.some(role =>
                                        ["DPAT TECHNICAL TEAM", "Superuser"].includes(role.name)
                                    ) && (
                                        <Button
                                            type="primary"
                                            onClick={showConfirm}
                                            style={{
                                                backgroundColor: "#16325a",
                                                borderColor: "#16325a",
                                            }}
                                            loading={progressLoad || assessmentStatusLoading}
                                            disabled={assessmentStatusLoading}
                                        >
                                            <span
                                                style={{
                                                    color: "white",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                CLICK TO START ASSESSMENT FOR {reportYear ?? year}
                                            </span>
                                        </Button>
                                    )}
                            </Col>
                            <div ref={contentToPrint} className="space-y-0">

                                <section className="card p-4 md:p-5">
                                    <div className="grid gap-4 md:grid-cols-3">
                                        <div>
                                            <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">MMDA</p>
                                            <p className="mt-1 text-sm font-medium text-foreground">{district?.label || "—"}</p>
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">Region</p>
                                            <p className="mt-1 text-sm font-medium text-foreground">{region || "—"}</p>
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-[0.12em] text-muted-foreground">
                                                {assessmentDateDisplay.label}
                                            </p>
                                            <p className="mt-1 text-sm font-medium text-foreground">{assessmentDateDisplay.value || "—"}</p>
                                            {assessmentDateDisplay.secondary ? (
                                                <p className="mt-0.5 text-xs text-muted-foreground">{assessmentDateDisplay.secondary}</p>
                                            ) : null}
                                        </div>
                                    </div>
                                </section>
                                <div className="space-y-5">
                                    {(user?.user?.userRoles?.some((role) =>
                                        [
                                            "DPAT QUALITY ASSURANCE",
                                            "DPAT PETITION COMMITTEE",
                                            "DPAT TECHNICAL TEAM",
                                            "DPAT DISTRICT USERS",
                                            "Superuser",
                                        ].includes(role.name)
                                    ) &&
                                        (assessmentStatus?.status === "Completed" ||
                                            assessmentStatus?.status === "Closed") ||
                                        showScoreSheetsAtTop) && (
                                        <DpatMemoAndScoresGate
                                            districtId={districtOrgUnitId}
                                            year={reportYear ?? year}
                                            showMemo={Boolean(
                                                user?.user?.userRoles?.some((role) =>
                                                    [
                                                        "DPAT QUALITY ASSURANCE",
                                                        "DPAT PETITION COMMITTEE",
                                                        "DPAT TECHNICAL TEAM",
                                                        "DPAT DISTRICT USERS",
                                                        "Superuser",
                                                    ].includes(role.name)
                                                ) &&
                                                (assessmentStatus?.status === "Completed" ||
                                                    assessmentStatus?.status === "Closed")
                                            )}
                                        >
                                    {(user?.user?.userRoles?.some((role) =>
                                        [
                                            "DPAT QUALITY ASSURANCE",
                                            "DPAT PETITION COMMITTEE",
                                            "DPAT TECHNICAL TEAM",
                                            "DPAT DISTRICT USERS",
                                            "Superuser",
                                        ].includes(role.name)
                                    )) &&
                                        (assessmentStatus?.status === "Completed" ||
                                            assessmentStatus?.status === "Closed") && (
                                            <>
                                                <h3 style={{ textAlign: "center", padding: "10px" }}>
                                                    MEMO SECTION
                                                </h3>
                                                <QualityAssuranceEditor
                                                    year={reportYear ?? year}
                                                    districtId={districtOrgUnitId}
                                                    district={district}
                                                    assessmentStatus={
                                                        assessmentStatus?.status === "Pending"
                                                    }
                                                />
                                                <hr />
                                            </>
                                        )}


                                    {showScoreSheetsAtTop && (
                                            <>
                                                <DpatScoreSheetsBlock
                                                    district={district}
                                                    districtId={districtOrgUnitId}
                                                    year={reportYear ?? year}
                                                    region={region}
                                                    hideRoleScoreColumns={hideRoleScoreColumnsForDistrictUser}
                                                    assessmentStartTables={assessmentStartTables}
                                                    hideLoader={Boolean(
                                                        user?.user?.userRoles?.some((role) =>
                                                            [
                                                                "DPAT QUALITY ASSURANCE",
                                                                "DPAT PETITION COMMITTEE",
                                                                "DPAT TECHNICAL TEAM",
                                                                "DPAT DISTRICT USERS",
                                                                "Superuser",
                                                            ].includes(role.name)
                                                        ) &&
                                                        (assessmentStatus?.status === "Completed" ||
                                                            assessmentStatus?.status === "Closed")
                                                    )}
                                                />

                                                <hr />
                                            </>
                                        )}
                                        </DpatMemoAndScoresGate>
                                        )}

                                    <Col align="end" style={{ marginBottom: "20px" }}>

                                    </Col>
                                    

                                    {(assessmentStatus?.status === "Closed" || assessmentStatus?.status === "Completed")
                                        && (user?.user?.userRoles?.some((role) =>
                                            ["Superuser", "DPAT DISTRICT USERS"].includes(role.name))) &&
                                         (
                                            <Petition
                                                year={reportYear ?? year}
                                                districtId={districtOrgUnitId}
                                                districtName={district?.label || district?.name || ""}
                                                hideComment={hideComment}
                                                assessmentStatus={assessmentStatus?.status !== "Closed"}
                                                district={districtOrgUnitId}
                                            />
                                        )}

                                    {(assessmentStatus?.status === "Closed" || assessmentStatus?.status === "Completed")
                                        && (user?.user?.userRoles?.some((role) =>
                                            ["DPAT PETITION COMMITTEE", "Superuser", "DPAT TECHNICAL TEAM"].includes(role.name))
                                            || ["ofsam", "fkwakye"].includes(String(user?.user?.username || "").trim().toLowerCase())) &&
                                         (
                                            <PetitionCommittee
                                                year={reportYear ?? year}
                                                districtId={districtOrgUnitId}
                                                districtName={district?.label || district?.name || ""}
                                                hideComment={hideComment}
                                                assessmentStatus={assessmentStatus?.status !== "Closed"}
                                                district={districtOrgUnitId}
                                                onRequestCloseAssessment={() => showClose("afterResponse")}
                                            />
                                        )}

                                    {annexModeToolbarEl}

                                    <div
                                        className="dpat-annex-slide"
                                        data-dpat-annex="1"
                                        style={{
                                            display: sheetAnnexMode === "full" || activeAnnexPage === 0 ? "block" : "none",
                                        }}
                                    >
                                        <h2 className="dpat-annex-heading">Annex 1: Section A — Compliance indicators</h2>

                                        {/* General Assembly Meetings and Decision Start */}
                                        {gaMeetingData && <GAMeeting
                                            ref={gaMeetingRef}
                                            data={gaMeetingData}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.gaMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {/* Approval of Annual Action Plan Budget Start */}
                                        <AAPBudgetAproval
                                            ref={aapBudgetApprovalRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.aapBudgetApproval}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        {/* Sub-Structures Meetings Start */}
                                        {subStructuresMeetingData && subStructureData && subReportData && <SubStructureMeeting
                                            ref={subStructureMeetingRef}
                                            data={subStructuresMeetingData}
                                            year={reportYear ?? year}
                                            columns={subStructureColumns}
                                            establishment={subStructureData}
                                            establishmentColumns={subStructureEstablishmentColumns}
                                            revenueSharing={subReportData}
                                            revenuSharingColumns={revenueSharingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.subStructureMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {/* ECA Meeting Start */}
                                        {ecaMeetingData && <ExecutiveCommitteeMember
                                            ref={executiveCommitteeMemberRef}
                                            data={ecaMeetingData}
                                            year={reportYear ?? year}
                                            columns={ECAMeetingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.executiveCommitteeMember}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {/* Sub Statutory Committee Meeting and Members section Start */}
                                        {subStatutoryData && <SubStructureCommiteeMeeting
                                            ref={subStructureCommitteeMeetingRef}
                                            data={subStatutoryData}
                                            meetingColumns={subStatutoryMeetingsColumns}
                                            memberColumns={membersColumns}
                                            districtId={districtOrgUnitId}
                                            year={reportYear ?? year}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.subStructureCommitteeMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {managementMeetingsData && <ManagementMeeting
                                            ref={managementMeetingRef}
                                            data={managementMeetingsData}
                                            year={reportYear ?? year}
                                            columns={managementMeetingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.managementMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {prccMeetingData && <PRCCMeeting
                                            ref={prccMeetingRef}
                                            data={prccMeetingData}
                                            year={reportYear ?? year}
                                            columns={PRCCMeetingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.prccMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {/* Special Committee Meeting (SPC) Meeting Start */}
                                        {etcMeetingData && <EntityTenderCommitteeMeeting
                                            ref={entityTenderCommitteeMeetingRef}
                                            data={etcMeetingData}
                                            year={reportYear ?? year}
                                            columns={spcMeetingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.entityTenderCommitteeMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {/* Entity Tender Committee (ETC) Meeting Start */}
                                        {spcMeetingData && <SPCEntityTenderCommittee
                                            ref={spcEntityTenderCommitteeRef}
                                            data={spcMeetingData}
                                            year={reportYear ?? year}
                                            columns={ETCMeetingColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.spcEntityTenderCommittee}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {internalAuditData && <InternalAuditUnitFunctionality
                                            ref={internalAuditUnitFunctionalityRef}
                                            data={internalAuditData}
                                            district={districtOrgUnitId}
                                            year={reportYear ?? year}
                                            columns={internalAuditColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.internalAuditUnitFunctionality}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {internalAuditMeetingData && <AuditCommiteeMeeting
                                            ref={auditCommitteeMeetingRef}
                                            meetings={internalAuditMeetingData}
                                            meetingColumns={internalAuditMeetingColumns}
                                            district={districtOrgUnitId}
                                            year={reportYear ?? year}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.auditCommitteeMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        <ClientServiceFunctionality
                                            ref={clientServiceFunctionalityRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.clientServiceFunctionality}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <AAPPublication
                                            ref={aapPublicationRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.aapPublication}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        {<AuditorGeneralGAMeeting
                                            ref={auditorGeneralGAMeetingRef}
                                            gaMeetings={gaMeetingData || []}
                                            documents={props?.documents}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.auditorGeneralGAMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {<TownHollMeeting
                                            ref={townHallMeetingRef}
                                            meetings={towHallMeetingData}
                                            columns={townHallMeetingColumns}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.townHallMeeting}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        {annexStepsNavEl}

                                        <div style={{ height: '4px', backgroundColor: '#000', width: '100%', margin: '20px 0' }} />

                                    </div>
                                    <div
                                        className="dpat-annex-slide"
                                        data-dpat-annex="2"
                                        style={{
                                            display: sheetAnnexMode === "full" || activeAnnexPage === 1 ? "block" : "none",
                                        }}
                                    >
                                        <h2 className="dpat-annex-heading">Annex 2: Section B — Service delivery indicators</h2>

                                        {/* SDI- General Assembly Decisions Start */}
                                        {decisionServiceData && <GeneralAssemblyDecision
                                            ref={generalAssemblyDecisionRef}
                                            data={decisionServiceData}
                                            year={reportYear ?? year}
                                            columns={serviceDecisionColumns}
                                            decisionDeliveryData={decisionDeliveryData}
                                            serviceDeliveryDecisionColumns={serviceDeliveryDecisionColumns}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            gaMeetingFulfillment={gaMeetingData?.fulfillment}
                                            savedAssessmentData={savedTables.generalAssemblyDecision}
                                            {...assessmentStartProps}
                                        />}

                                        <hr />

                                        <GeneralAssemblyManagementActions
                                            ref={generalAssemblyManagementActionsRef}
                                            year={reportYear ?? year}
                                            decisions={decisionDeliveryListData}
                                            managementActionServiceDeliveryData={managementActionServiceDeliveryData}
                                            district={districtOrgUnitId}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.generalAssemblyManagementActions}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <GASupport
                                            ref={gaSupportRef}
                                            year={reportYear ?? year}
                                            cededRevenueUtilisationData={cededRevenueUtilisationData}
                                            subStructureActivityData={subStructureActivityData}
                                            cededRevenueUtilisationScore={cededRevenueUtilisationScore}
                                            substructureExpendature={substructureExpendatureData}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.gaSupport}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <WaterServices
                                            ref={waterServicesRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            documents={props?.documents}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.waterServices}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <ElectricityServices
                                            ref={electricityServicesRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            documents={props?.documents}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.electricityServices}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <SanitationServices
                                            ref={sanitationServicesRef}
                                            year={reportYear ?? year}
                                            plans={props?.plans}
                                            ifg={props?.ifg}
                                            documents={props?.documents}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.sanitationServices}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <MaintenanceInfrastructure
                                            ref={maintenanceInfrastructureRef}
                                            year={reportYear ?? year}
                                            buildingInspectorateData={buildingInspectorateData}
                                            documents={props?.documents}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.maintenanceInfrastructure}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <ClientServiceCharter
                                            ref={clientServiceCharterRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            documents={props?.documents}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.clientServiceCharter}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <TransportationNetworkService
                                            ref={transportationNetworkServiceRef}
                                            year={reportYear ?? year}
                                            transportors={transportorsData}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.transportationNetworkService}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <BuildingInspectorateUnit
                                            ref={buildingInspectorateUnitRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.buildingInspectorateUnit}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <PermitProcessingIssuance
                                            ref={permitProcessingIssuanceRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            documents={props?.documents}
                                            meetings={props?.meetings}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.permitProcessingIssuance}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <StreetNaming
                                            ref={streetNamingRef}
                                            year={reportYear ?? year}
                                            district={districtOrgUnitId}
                                            streets={streetNamingData}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.streetNaming}
                                            {...assessmentStartProps}
                                            columns={streetNamingColumn}
                                        />

                                        <hr />

                                        <SocialProtectionServices
                                            ref={socialProtectionServicesRef}
                                            year={reportYear ?? year}
                                            district={districtOrgUnitId}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.socialProtectionServices}
                                            {...assessmentStartProps}
                                            services={socialServicesData}
                                            documents={props?.documents}
                                        />

                                        <hr />


                                        <DistrictHotlineNumber
                                            ref={districtHotlineNumberRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.districtHotlineNumber}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <PWDService
                                            ref={pwdServiceRef}
                                            year={reportYear ?? year}
                                            district={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.pwdService}
                                            {...assessmentStartProps}
                                            districtId={districtOrgUnitId}
                                        />

                                        <hr />

                                        <DeepeningGenderMainstreaming
                                            ref={deepeningGenderMainstreamingRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.deepeningGenderMainstreaming}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <NutritionIntervention
                                            ref={nutritionInterventionRef}
                                            year={reportYear ?? year}
                                            district={districtOrgUnitId}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.nutritionIntervention}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <SanitationServiceProviders
                                            ref={sanitationServiceProvidersRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.sanitationServiceProviders}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            document={sanitationServiceList}
                                        />

                                        <hr />

                                        <DumpingSite
                                            ref={dumpingSiteRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.dumpingSite}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <FoodVendors
                                            ref={foodVendorsRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.foodVendors}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <PublicSchoolFacility
                                            ref={publicSchoolFacilityRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.publicSchoolFacility}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <ClimateChangeIntervention
                                            ref={climateChangeInterventionRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.climateChangeIntervention}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <DistrictLEDActivityPlan
                                            ref={districtLEDActivityPlanRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.districtLEDActivityPlan}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <BusinessAndJobPromotion
                                            ref={businessAndJobPromotionRef}
                                            year={reportYear ?? year}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.businessAndJobPromotion}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <AgroProcessingFacilitySupport
                                            ref={agroProcessingFacilitySupportRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.agroProcessingFacilitySupport}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <BusinessCommunityEngagement
                                            ref={businessCommunityEngagementRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.businessCommunityEngagement}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        {annexStepsNavEl}

                                        <div style={{ height: '4px', backgroundColor: '#000', width: '100%', margin: '20px 0' }} />

                                    </div>
                                    <div
                                        className="dpat-annex-slide"
                                        data-dpat-annex="3"
                                        style={{
                                            display: sheetAnnexMode === "full" || activeAnnexPage === 2 ? "block" : "none",
                                        }}
                                    >
                                        <h2 className="dpat-annex-heading">Annex 3: Section C — Performance indicators</h2>

                                        <AAPImplementation
                                            ref={aapImplementationRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.aapImplementation}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <MonitoringProjectAndActivity
                                            ref={monitoringProjectAndActivityRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.monitoringProjectAndActivity}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <ContractManagementAndAdmins
                                            ref={contractManagementAndAdminsRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.contractManagementAndAdmins}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            data={projectProgrammeData}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <FollowUpDeduction
                                            ref={followUpDeductionRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.followUpDeduction}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            data={projectProgrammeData}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <EnvironmentalAndSocialSafeGuard
                                            ref={environmentalAndSocialSafeGuardRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            data={projectProgrammeData}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.environmentalAndSocialSafeGuard}
                                            {...assessmentStartProps}
                                        />

                                        <hr />

                                        <RateableRevenu
                                            ref={rateableRevenueRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.rateableRevenue}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            documents={props?.documents}
                                            ifg={props?.ifg}
                                        />

                                        <hr />

                                        <AuditCommitteeResponsiveness
                                            ref={auditCommitteeResponsivenessRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.auditCommitteeResponsiveness}
                                            {...assessmentStartProps}
                                            audits={auditCommitteeMeetingData}
                                        />

                                        <hr />

                                        <AuditInfractions
                                            ref={auditInfractionsRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.auditInfractions}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                            documents={props?.documents}
                                        />

                                        <hr />

                                        <EducationServiceSupport
                                            ref={educationServiceSupportRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.educationServiceSupport}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <HealthServiceSupport
                                            ref={healthServiceSupportRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.healthServiceSupport}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />

                                        <hr />

                                        <AgricultureSupport
                                            ref={agricultureSupportRef}
                                            year={reportYear ?? year}
                                            districtId={districtOrgUnitId}
                                            hideComment={hideComment}
                                            savedAssessmentData={savedTables.agricultureSupport}
                                            {...assessmentStartProps}
                                            district={districtOrgUnitId}
                                        />


                                        <hr />

                                        {annexStepsNavEl}

                                        <div style={{ height: '4px', backgroundColor: '#000', width: '100%', margin: '20px 0' }} />

                                    </div>
                                    <div
                                        className="dpat-annex-slide"
                                        data-dpat-annex="4"
                                        style={{
                                            display: sheetAnnexMode === "full" || activeAnnexPage === 3 ? "block" : "none",
                                        }}
                                    >
                                        {showScoreSheetsInAnnex4 && (
                                            <>
                                                <DpatScoreSheetsBlock
                                                    district={district}
                                                    districtId={districtOrgUnitId}
                                                    year={reportYear ?? year}
                                                    region={region}
                                                    hideRoleScoreColumns={hideRoleScoreColumnsForDistrictUser}
                                                    assessmentStartTables={assessmentStartTables}
                                                />

                                                <hr />
                                            </>
                                        )}

                                        {!user?.user?.userRoles?.some(role => role.name === "DPAT DISTRICT USERS") && (
                                            <>
                                                <h3 style={{ textAlign: "center", padding: "10px" }}>ANNEX 5 SUMMARY OF COMMENTS</h3>
                                                <CommentAndGabsSummary district={district} region={region} year={reportYear ?? year} />
                                                <hr />
                                            </>
                                        )}
                                        {!user?.user?.userRoles?.some(role => role.name === "DPAT DISTRICT USERS") && (
                                            <>
                                                <h3 style={{ textAlign: "center", padding: "10px" }}>
                                                    SUMMARY OF QUALITY ASSURANCE COMMENTS
                                                </h3>
                                                <QualityAssuranceCommentsSummary
                                                    district={district}
                                                    year={reportYear ?? year}
                                                />
                                                <hr />
                                            </>
                                        )}
                                        {(user?.user?.userRoles?.some(role =>
                                            ["DPAT QUALITY ASSURANCE", "Superuser"].includes(role.name)
                                        )) && assessmentStatus?.status === "Pending" && (
                                            <DpatMemoAndScoresGate
                                                districtId={districtOrgUnitId}
                                                year={reportYear ?? year}
                                                showMemo
                                            >
                                                <h3 style={{ textAlign: "center", padding: "10px" }}>MEMO SECTION</h3>
                                                <QualityAssuranceEditor
                                                    year={reportYear ?? year}
                                                    districtId={districtOrgUnitId}
                                                    district={district}
                                                    assessmentStatus={assessmentStatus?.status === "Pending"}
                                                />
                                                <hr />
                                            </DpatMemoAndScoresGate>
                                        )}
                                        {annexStepsNavEl}

                                        <div style={{ height: "4px", backgroundColor: "#000", width: "100%", margin: "20px 0" }} />
                                    </div>
                                    {/* Print Button */}


                                </div>
                            </div>
                            <section className="card flex flex-wrap items-center justify-end gap-3 p-4 md:p-5">
                                {/* <Col span={10} className="gutter-row"> */}

                                {/* </Col> */}
                                <UiButton
                                    type="button"
                                    onClick={() => {
                                        if (contentToPrint.current) {
                                            handlePrint();
                                        } else {
                                            console.log("Content is not available for printing.");
                                        }
                                    }}
                                >
                                    <Icon name="Download" className="h-4 w-4" />
                                    Download report
                                </UiButton>

                                {(user?.user?.userRoles?.some(role =>
                                    ["DPAT TECHNICAL TEAM", "Superuser"].includes(role.name)
                                )) && (assessmentStatus?.status === "Start") && (
                                        <Button
                                            type="primary"
                                            onClick={showPending}
                                            style={{
                                                backgroundColor: "#2e7f05ff",
                                                borderColor: "#2e7f05ff",
                                                marginLeft: "30px"
                                            }}
                                            loading={progressLoad}
                                        >
                                            <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
                                                COMPLETE ASSESSMENT
                                            </span>
                                        </Button>
                                    )}

                                {(user?.user?.userRoles?.some((role) =>
                                    ["DPAT QUALITY ASSURANCE", "Superuser"].includes(role.name),
                                )) &&
                                    assessmentStatus?.status === "Pending" && (
                                        <Button
                                            type="primary"
                                            onClick={showComplete}
                                            style={{
                                                backgroundColor: "#338e06ff",
                                                borderColor: "#338e06ff",
                                                marginLeft: "30px",
                                            }}
                                            loading={progressLoad}
                                        >
                                            <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
                                                COMPLETE QA REVIEW
                                            </span>
                                        </Button>
                                    )}

                                {(user?.user?.userRoles?.some((role) => role.name === "Superuser") &&
                                    !user?.user?.userRoles?.some((role) => role.name === "DPAT PETITION COMMITTEE") &&
                                    assessmentStatus?.status === "Completed") && (
                                        <Button
                                            type="primary"
                                            onClick={() => showClose()}
                                            style={{
                                                backgroundColor: "#a00000ff",
                                                borderColor: "#a00000ff",
                                                marginLeft: "30px"
                                            }}
                                            loading={progressLoad}
                                        >
                                            <span style={{ color: "white", fontSize: "14px", fontWeight: "bold" }}>
                                                CLOSE ASSESSMENT
                                            </span>
                                        </Button>
                                    )}




                            </section>

                        </>
                    ) : null}

                </div>
            </div>
            </DpatCommentFeedbackProvider>
        </DpatDocumentViewerProvider>
    );
};

export default DPATAssessmentSheet;
